export default {
  translation: {
    help: {
      title: "Hjälp",
      center: "Hjälpcenter",
      minimize: "Minimera",
      expand: "Förstora",
      shrink: "Förminska",
      askIntro:
        "Hej! Ställ en fråga om hur något fungerar. Svaren bygger på hjälpcentret och länkar till källorna.",
      askPlaceholder: "Skriv din fråga",
      send: "Skicka",
      thinking: "Tänker…",
      newConversation: "Ny",
      error: "Assistenten kunde inte svara. Försök igen.",
      rateLimited: "För många frågor just nu. Försök igen om en stund.",
      openingHelp: "Öppnar hjälpcentret…",
      sessionFailed: "Kunde inte öppna hjälpcentret. Försök igen.",
    },
    common: {
      loading: "Laddar...",
      errorLoadingUser: "Fel vid laddning av användare",
      yes: "Ja",
      no: "Nej",
      retry: "Försök igen",
      initializing: "Startar...",
      save: "Spara",
      update: "Uppdatera",
      cancel: "Avbryt",
      delete: "Ta bort",
      edit: "Redigera",
      create: "Skapa",
      close: "Stäng",
      back: "Tillbaka",
      search: "Sök",
      noMatches: "Inga träffar",
      actions: "Åtgärder",
      name: "Namn",
      email: "E-post",
      status: "Status",
      loadingEllipsis: "Laddar...",
      listIdSubtitle: "ID: {{id}}",
      copiedToClipboard: "Kopierat till urklipp!",
      saveChanges: "Spara ändringar",
      saving: "Sparar...",
      updating: "Uppdaterar...",
      creating: "Skapar...",
      type: "Typ",
      amount: "Belopp",
      remove: "Ta bort",
    },
    catalogOrigin: {
      STORE: "Endast denna butik",
      CHAIN: "Hela kedjan",
    },
    catalogOriginShort: {
      STORE: "B",
      CHAIN: "K",
    },
    multiCurrencyMoneyInput: {
      addCurrency: "Lägg till valuta",
    },
    language: {
      swedish: "Svenska",
      english: "Engelska",
      chooseLanguage: "Språk",
    },
    app: {
      loadingStores: "Laddar butiker...",
      errorLoadingStores: "Fel vid laddning av butiker. Försök igen.",
      noStoresAvailable: "Inga butiker tillgängliga",
    },
    login: {
      email: "E-post",
      password: "Lösenord",
      emailPlaceholder: "Ange din e-post",
      passwordPlaceholder: "Ange ditt lösenord",
      signIn: "Logga in",
      signingIn: "Loggar in...",
      logoAlt: "Kassaro",
      errors: {
        generic: "Inloggning misslyckades",
      },
    },
    storeSelector: {
      title: "Välj butik",
      subtitle: "Välj en butik för att fortsätta",
    },
    navbar: {
      toggleMenu: "Växla meny",
      staging: "Staging",
      storeSearchPlaceholder: "Sök butiker…",
      storeSearchSearching: "Söker…",
      storeSearchNoResults: "Inga butiker hittades",
    },
    adminSidebar: {
      sectionTitle: "Adminverktyg",
      dashboard: "Översikt",
      stores: "Butiker",
      availableBillingItems: "Paket/tillägg",
      bundles: "Versioner",
      apiKeys: "API-nycklar",
      chains: "Kedjor",
      resellers: "Återförsäljare",
      kickback: "Kickback",
    },
    resellerSidebar: {
      sectionTitle: "Återförsäljare",
      overview: "Översikt",
      stores: "Butiker",
      users: "Användare",
      invoicing: "Fakturering",
      availableBillingItems: "Paket/tillägg",
      priceList: "Prislista",
    },
    chainSidebar: {
      sectionTitle: "Kedja",
      overview: "Översikt",
      stores: "Butiker",
      statistics: "Statistik",
      storeDebts: "Skuld mellan butiker",
      catalog: "Katalog",
      settings: "Inställningar",
    },
    catalog: {
      products: "Produkter",
      productGroups: "Varugrupper",
      units: "Enheter",
      courses: "Serveringar",
      prepStations: "Bongplatser",
      modifiers: "Tillval",
      modifierGroups: "Tillvalsgrupper",
      bookkeepingAccounts: "Bokföringskonton",
      productPages: "Produktsidor",
      offers: "Erbjudanden",
      suppliers: "Leverantörer",
      layouts: "Layouter",
      giftCards: "Presentkort",
      itemNotFound: "Objektet hittades inte.",
      unsavedTitle: "Osparade ändringar",
      unsavedMessage: "Du har osparade ändringar. Vill du kasta dem och lämna?",
      discard: "Kasta",
    },
    guards: {
      redirecting: "Omdirigerar...",
    },
    storeDropdown: {
      selectStore: "Välj butik",
    },
    userDropdown: {
      signOut: "Logga ut",
    },
    firebaseConsole: {
      openDocument: "Firestore",
    },
    gcpLogs: {
      openQuery: "Loggar",
    },
    overview: {
      loadingStore: "Laddar butik...",
      loadingStoreInfo: "Laddar butiksuppgifter...",
      storeNotFound: "Butiken hittades inte",
      storeName: "Juridiskt namn",
      displayName: "Visningsnamn",
      organizationNumber: "Organisationsnummer",
      address: "Adress",
      contactPerson: "Kontaktperson",
      contactEmail: "Kontakt e-post",
      contactPhone: "Kontakttelefon",
      country: "Land",
      currency: "Valuta",
      language: "Språk",
      timeZone: "Tidszon",
      chain: "Kedja",
      reseller: "Återförsäljare",
      noReseller: "Ingen återförsäljare",
      createdAt: "Skapad",
      dailySalesLast30Days: "Daglig försäljning (Senaste 30 dagarna)",
      saveStore: "Spara",
      savingStore: "Sparar…",
      orgNumberReadOnlyHint:
        "Organisationsnumret kan inte ändras medan butiken har en aktiv kassa.",
      updateStoreFailed: "Kunde inte spara ändringarna.",
      storeSaved: "Butiksuppgifterna sparades.",
    },
    billingItems: {
      addButton: "Lägg till paket, tillägg och hårdvara",
      switchPackage: "Byt paket",
      switchPackageConfirm: "Byt paket",
      manageAddons: "Hantera tillägg",
      addOtherItems: "Lägg till terminaler och hårdvara",
      noAddonsAvailable: "Inga tillägg är tillgängliga för denna butik.",
      noOtherItemsAvailable:
        "Inga betalterminaler eller hårdvara är tillgängliga för denna butik.",
      itemNames: {},
      sectionTitle: "Nuvarande faktureringsposter",
      loading: "Laddar...",
      empty: "Inga faktureringsposter ännu.",
      table: {
        name: "Namn",
        type: "Typ",
        invoicePeriod: "Faktureringsperiod",
        timeline: "Antal över tid",
        startDate: "Startdatum",
        endDate: "Slutdatum",
        paidUntil: "Betald till",
        status: "Status",
      },
      timeline: {
        segment: "{{quantity}} från {{from}} till {{until}}",
        ongoing: "vidare",
        untilFurtherNotice: "tills vidare",
      },
      status: {
        upcoming: "Kommande",
        active: "Aktiv",
        ended: "Avslutad",
        ordered: "Beställd",
      },
      type: {
        PACKAGE: "Paket",
        ADD_ON: "Tillägg",
        HARDWARE: "Hårdvara",
        PAYMENT_METHOD: "Betalterminal",
        EXTRA_DEVICE: "Extra enhet",
      },
      billingPeriod: {
        MONTHLY: "Månadsvis",
        QUARTERLY: "Kvartalsvis",
        YEARLY: "Årlig",
        TWO_YEARS: "2 år",
        THREE_YEARS: "3 år",
        FOUR_YEARS: "4 år",
        FIVE_YEARS: "5 år",
      },
      hardware: {
        category: {
          handheld: "Handhållna",
          tablet: "Surfplattor",
          desktop: "Stationära",
          other: "Övrigt",
        },
      },
      actions: {
        activate: "Aktivera nu",
        activating: "Aktiverar...",
        cancel: "Avsluta",
        cancelling: "Avslutar...",
        cancelConfirm:
          "Är du säker på att du vill avsluta denna faktureringspost?",
      },
      edit: {
        isDemo: "Demo",
        paidUntil: "Betald till",
        discountAmount: "Rabattbelopp",
        startDateLocked:
          "Startdatum och faktureringsperiod kan inte ändras när faktureringsperioden har börjat.",
        segments: "Antalsperioder",
        addSegment: "Lägg till period",
        removeSegment: "Ta bort period",
        duplicateSegmentDates: "Varje period måste ha ett unikt startdatum.",
        endDateInPast: "Slutdatum kan inte vara i det förflutna.",
        endDateBeforeMinimum:
          "Slutdatum måste vara minst en månad efter startdatum ({{minimumDate}}). Det justeras automatiskt vid sparning.",
        effectiveFromBeforeMinimum:
          "Ändringar kan inte träda i kraft före {{minimumDate}}. Datumet justeras automatiskt vid sparning.",
        cancelBeforeMinimum:
          "Denna faktureringspost måste vara aktiv till minst {{minimumDate}}. Avslut nu träder i kraft från det datumet.",
        endDatePaidUntilLimit:
          "Denna post är betald till {{paidUntilDate}}. Slutdatum kan inte sättas före det datumet.",
        endDateBeforePaidUntil:
          "Slutdatum kan inte vara före betald-till-datum ({{paidUntilDate}}).",
      },
    },
    kickback: {
      title: "Kickback",
      description:
        "Beräkna återförsäljarnas andel av Viva ISV-avgifter samt Paytrim- och Elavon-ersättning och dra av den som negativa rader överst på återförsäljarens faktura. Välj samma period som fakturan har under Fakturering: fakturan som genereras i början av oktober har perioden oktober och får Viva för september samt Paytrim och Elavon för augusti, eftersom de rapporterar en månad senare. Återförsäljarens andel är beloppet exklusive moms (× 0,8) delat på två.",
      loadError: "Kickback kunde inte laddas.",
      loading: "Laddar kickback...",
      period: "Fakturaperiod",
      dataPeriod: "Avser",
      source: {
        VIVA: "Viva ISV-avgift",
        PAYTRIM: "Paytrim",
        ELAVON: "Elavon",
      },
      sourceHint: {
        VIVA: "Hämtas från Viva för hela månaden. Merchant-ID matchas mot kedjornas Viva-integrationer.",
        PAYTRIM: "Excelfil med kolumnerna Name och Compensation för månaden under Avser. Företagsnamnen matchas mot butiker.",
        ELAVON: "Excelfil med kolumnerna Name och Compensation för månaden under Avser. Företagsnamnen matchas mot butiker.",
      },
      notLoaded: "Inte hämtad för perioden.",
      updatedAt: "Uppdaterad",
      file: "Fil",
      grossAmount: "Belopp inkl. moms",
      profitShare: "Återförsäljarens andel",
      unmatched: "Utan återförsäljare",
      skippedRows: "Rader utan giltigt belopp",
      fetchViva: "Hämta från Viva",
      refetchViva: "Hämta om",
      fetching: "Hämtar...",
      uploadReport: "Ladda upp rapport",
      uploading: "Laddar upp...",
      unmatchedTitle: "Rader utan återförsäljare",
      unmatchedDescription:
        "De här raderna kommer inte med på någon faktura. Välj butik för företag från Paytrim och Elavon; valet sparas och används även nästa period. Om butiken redan är vald saknar den återförsäljare.",
      sourceColumn: "Källa",
      reference: "Företag / merchant-ID",
      matchedTo: "Matchad mot",
      match: "Välj butik",
      noMatch: "Ingen matchning",
      noReseller: "saknar återförsäljare",
      vivaUnmatchedHint: "Lägg till Viva-integrationen på rätt kedja och hämta om.",
      perResellerTitle: "Per återförsäljare",
      perResellerDescription:
        "Beloppen dras av överst på återförsäljarens faktura för samma period när fakturan genereras under Fakturering. Är fakturan redan genererad men inte skickad, generera den igen för att få med ändringar.",
      noResellerTotals: "Ingen kickback för perioden ännu.",
      reseller: "Återförsäljare",
      rows: "Rader",
    },
    invoice: {
      kickbackRow: "Kickback – {{source}}",
      kickbackMissing:
        "Ingen kickbackrapport fanns för {{sources}} när fakturan genererades. Ladda upp eller hämta under Kickback och generera fakturan igen om de ska med.",
      kickbackType: "Kickback",
      sectionTitle: "Fakturering",
      loading: "Laddar fakturor...",
      emptyList: "Inga fakturor ännu.",
      generateButton: "Generera faktura",
      generating: "Genererar...",
      markAsSent: "Skapa utkast i Bokio",
      markingAsSent: "Skapar utkast...",
      panelTitle: "Fakturaförhandsvisning",
      period: "Period",
      generatedAt: "Genererad",
      total: "Totalt",
      sent: "I Bokio",
      empty: "Inga rader i denna faktura.",
      lineItem: {
        name: "Namn",
        type: "Typ",
        store: "Butik",
        period: "Period",
        months: "Månader",
        unitPrice: "Enhetspris",
        total: "Totalt",
      },
    },
    availableBillingItemsView: {
      title: "Paket/tillägg",
      loading: "Laddar paket/tillägg...",
      createButton: "Skapa paket/tillägg",
      errorLoading: "Fel vid laddning av paket/tillägg. Försök igen.",
      errorUpdating: "Fel vid uppdatering av paket/tillägg. Försök igen.",
      successCreated: "Paket/tillägg skapat",
      successUpdated: "Paket/tillägg uppdaterad",
      successArchived: "Paket/tillägg arkiverat",
      empty: "Inga paket/tillägg ännu. Skapa en för att komma igång.",
      table: {
        name: "Namn",
        type: "Typ",
        pricing: "Priser",
        actions: "Åtgärder",
      },
      archive: "Arkivera",
      archived: "Arkiverad",
      archiveConfirm:
        "Arkivera detta paket/tillägg? Det tas bort från återförsäljarnas kataloger och kan inte längre läggas till i butiker. Befintliga prenumerationer påverkas inte.",
      panelCreateTitle: "Skapa paket/tillägg",
      panelEditTitle: "Redigera paket/tillägg: {{name}}",
      pricing: {
        monthly: "Månadsvis",
        oneTime: "Engångs",
        prepaid36: "36 mån",
      },
    },
    availableBillingItemForm: {
      type: "Typ",
      selectType: "Välj en typ",
      name: "Namn",
      description: "Beskrivning",
      comingSoon: "Kommer snart",
      comingSoonLabel: "Markera som kommer snart",
      bulletsOptional: "Punkter (valfritt)",
      bulletPoint: "Punkt {{index}}",
      addBullet: "Lägg till punkt",
      remove: "Ta bort",
      categoryOptional: "Kategori (valfritt)",
      selectCategory: "Välj en kategori",
      features: "Funktioner",
      feature: {
        FISCALIZATION: "Kassaregister",
        DISCOUNT: "Rabatt",
        GROUPS: "Varugrupper",
        PRODUCT_VARIANTS: "Produktvarianter",
        RESTAURANT_VARIANTS: "Restaurangvarianter",
        LAYOUTS: "Layouter",
        FLOOR_PLANS: "Bordskarta",
        CREDIT_NOTE: "Tillgodokvitto",
        GIFT_CARD: "Presentkort",
        AUTOMATIC_BOOKKEEPING: "Automatisk bokföring",
        RECEIPT_LOGO: "Kvittologotyp",
        EXTRA_PRODUCT_FIELDS: "Extra produktfält",
        CUSTOMER_DISPLAY: "Kunddisplay",
        BARCODE_SCANNING: "Streckkodsskanning",
        SIMPLE_STOCK: "Lagersaldo",
        PHONE_SUPPORT: "Telefonsupport",
        BUNDLE_MANAGEMENT: "Versionshantering",
        LABEL_PRINTING: "Etikettutskrift",
        ORDER: "Order",
        INVOICE: "Faktura",
        PURCHASE_NOTE: "Inköpsnota",
        SERIAL_SCALE: "Seriell våg",
        PRODUCT_INFO_BOX: "Produktinformation",
        MODIFIERS: "Tillval",
        TIPS: "Dricks",
        PREP_TICKETS: "Bongar",
        COMBINED_PREP_TICKETS: "Kombinerad bong",
        SAVE_TABS: "Parkera notor",
        SPLIT_TABS: "Dela notor",
        BILL_PREVIEW: "Förnota",
        TAKEOUT_PRICE: "Avhämtningspris",
        ONLINE_ORDER: "Onlinebeställning",
        PURCHASE_PRICE: "Inköpspris",
        STAFF: "Personal",
        INTAKE: "Inleverans",
        PRODUCT_SYNC: "Produktsynk",
        PRODUCT_IMAGES: "Produktbilder",
        STOCK_TAKE: "Inventering",
        STOCK_LOCATIONS: "Lagerplatser",
        STOCK_POLICIES: "Lagerregler",
        INVENTORY_COSTING: "FIFO-värdering och serienummer",
        SUPPLIERS: "Leverantörer",
        OFFERS: "Erbjudanden",
        CUSTOMERS: "Kunder",
        SERVICE_ORDERS: "Serviceordrar",
        EXTERNAL_INTEGRATIONS: "Externa integrationer",
        PUBLIC_API: "Öppet API och webhooks",
      },
      grants: "Inkluderad kapacitet",
      grantsAdditionalDevices: "Ytterligare enheter som ingår",
      grantsPaymentTerminals: "Betalterminaler som ingår (valfritt)",
      grantsPaymentTerminalCount: "Antal",
      addPaymentTerminal: "Lägg till betalterminal",
      grantsNotIncluded: "Ingår ej",
      paymentProvider: {
        SOFTPAY: "Softpay",
        WESTPAY: "Westpay",
        MARKETPAY: "Marketpay",
        VIVA: "Viva",
        NETS: "Nets",
      },
      image: "Bild",
      selectedImage: "Vald: {{name}} ({{size}} KB)",
      imagePreviewAlt: "Bildförhandsvisning",
      monthlyPriceOptional: "Månadspris (valfritt)",
      oneTimePriceOptional: "Engångspris (valfritt)",
      prepaid36MonthPriceOptional: "Förbetalning 36 månader pris (valfritt)",
      amountPlaceholder: "Belopp (kr)",
      cancel: "Avbryt",
      create: "Skapa",
      update: "Uppdatera",
    },
    statistics: {
      title: "Statistik",
      loading: "Laddar statistik...",
      retry: "Försök igen",
      days: "Dagar",
      weeks: "Veckor",
      months: "Månader",
      weekLabel: "Vecka {{number}}",
      weekLabelWithYear: "Vecka {{number}} {{year}}",
      totalSalesAmount: "Totala försäljningsbelopp",
      overviewTotalSales: "Total försäljning",
      overviewTotalRefunds: "Totala återbetalningar",
      overviewTotalDiscounts: "Totala rabatter",
      overviewReceiptCount: "Antal kvitton",
      mostSoldProducts: "Mest sålda produkter",
      mostSoldGroups: "Mest sålda grupper",
      quantityUnit: "st",
      productsColumnName: "Produkt",
      productsColumnCost: "Varukostnad",
      productsColumnMargin: "Marginal",
      productsCostProvisional:
        "* Preliminär varukostnad: mer såldes än det fanns i lager, eller så är kostnaden inte beräknad än.",
      groupsColumnName: "Grupp",
      receiptTypes: "Kvittotyper",
      receiptTypesColumnType: "Typ",
      receiptTypesColumnCount: "Antal",
      receiptTypesColumnAmount: "Belopp",
      salesByPaymentMethod: "Försäljning per betalmetod",
      hourOfDay: "Försäljning per timme",
      orderByQuantity: "Efter antal",
      orderByAmount: "Efter belopp",
      noProductsSold: "Inga produkter sålda",
      noGroupsSold: "Inga grupper sålda",
      couldNotLoadReport: "Kunde inte ladda rapport",
      back: "Tillbaka",
      previousPeriod: "Föregående period",
      nextPeriod: "Nästa period",
      selectPeriod: "Välj period",
      startDate: "Startdatum",
      endDate: "Slutdatum",
      apply: "Använd",
      refresh: "Uppdatera",
      refreshing: "Uppdaterar...",
      lastUpdated: "Senast uppdaterad {{time}}",
      updatedMinutesAgo: "Uppdaterad för {{minutes}} min sedan",
      refreshDisabledCooldown: "Statistiken kan uppdateras högst var 30:e minut. Försök igen om {{minutes}} min.",
      storesIncluded: "{{included}} av {{total}} butiker",
      stores: "Butiker",
      storeColumnName: "Butik",
      storeShare: "Andel",
      clearStoreFilter: "Visa alla butiker",
      showingStore: "Visar {{name}}",
      receiptType: {
        RECEIPT: "Kvitto",
        REFUND: "Återbetalning",
        PAYOUT: "Inköpsnota",
        INVOICE: "Faktura",
        ORDER: "Beställning",
      },
    },
    resellerTopList: {
      sectionTitle: "Återförsäljar-topplista",
      reseller: "Återförsäljare",
      activeCustomers: "Aktiva kunder",
      activeLicenses: "Aktiva licenser",
      customerGrowth: "Kundtillväxt",
      customerBreakdown: "{{added}} nya, {{removed}} förlorade",
      licenseBreakdown: "{{added}} nya, {{removed}} borttagna",
      licenseGrowth: "Licenstillväxt",
      datesSubtitle: "Jämfört med {{baselineDate}}, per {{asOfDate}}",
      empty: "Ingen rankingdata för denna månad",
      anonymousRank: "#{{rank}}",
      you: "Du",
    },
    licenseChanges: {
      sectionTitle: "Licensförändringar",
      store: "Butik",
      reseller: "Återförsäljare",
      license: "Licens",
      change: "Ändring",
      date: "Datum",
      status: "Status",
      statusNew: "Ny",
      statusTerminated: "Avslutad",
      statusChanged: "Bytt",
      statusQuantityChanged: "Ändrat antal",
      filterAll: "Alla förändringar",
      filterAdded: "Nya licenser (+{{count}})",
      filterRemoved: "Borttagna licenser (−{{count}})",
      empty: "Inga licensförändringar denna månad",
    },
    adminMrrStats: {
      sectionTitle: "MRR och ARR",
      mrrToday: "MRR idag ({{currency}})",
      mrrOnDate: "MRR ({{currency}}, {{date}})",
      arrToday: "ARR idag ({{currency}})",
      arrOnDate: "ARR ({{currency}}, {{date}})",
      payingStoresToday: "Betalande butiker idag",
      payingStoresOnDate: "Betalande butiker ({{date}})",
      comparedTo: "jämfört med {{date}}",
      noComparison: "Ingen data för {{date}}",
      mrrPerDay: "MRR per dag ({{currency}})",
      currentPeriod: "Vald period",
      previousPeriod: "Föregående period",
    },
    adminLicenseStats: {
      sectionTitle: "Licenser",
      activeLicensesPerDay: "Aktiva licenser per dag",
      recalculateToday: "Beräkna om idag",
      computing: "Beräknar...",
      uniqueStores: "Unika butiker",
      uniqueStoresToday: "Unika butiker idag",
      uniqueStoresOnDate: "Unika butiker ({{date}})",
      totalLicensesToday: "Totalt antal licenser idag",
      totalLicensesOnDate: "Totalt antal licenser ({{date}})",
      packagesToday: "Paket idag",
      packagesOnDate: "Paket ({{date}})",
      addOnsToday: "Tillägg idag",
      addOnsOnDate: "Tillägg ({{date}})",
      licenseTypesToday: "Licenstyper (idag)",
      licenseTypesOnDate: "Licenstyper ({{date}})",
      noDataToday: "Ingen data för idag ännu",
      noDataOnDate: "Ingen data för {{date}} ännu",
    },
    adminDailySales: {
      sectionTitle: "Kundomsättning",
      dailySalesChart: "Daglig kundomsättning",
      maxPeriodDays: "Högst {{days}} dagar per period",
      period: {
        thisMonth: "Denna månad",
        lastMonth: "Förra månaden",
        last30Days: "Senaste 30 dagarna",
        custom: "Anpassad",
      },
      receiptsToday: "Kvitton idag",
      receiptsOnDate: "Kvitton ({{date}})",
      grossSalesToday: "Kundomsättning idag ({{currency}})",
      grossSalesTodayGeneric: "Kundomsättning idag",
      grossSalesOnDate: "Kundomsättning ({{currency}}, {{date}})",
      grossSalesOnDateGeneric: "Kundomsättning ({{date}})",
      grossSales: "Kundomsättning",
      periodTotalSales: "Total kundomsättning ({{period}})",
      receiptCount: "Antal kvitton",
      paymentMethods: "Betalmetoder",
      paymentMethodsToday: "Betalmetoder (idag)",
      paymentMethodsOnDate: "Betalmetoder ({{date}})",
      other: "Övrigt",
      salesByCurrencyToday: "Kundomsättning per valuta (idag)",
      salesByCurrencyOnDate: "Kundomsättning per valuta ({{date}})",
      salesByReceiptTypeToday: "Kundomsättning per kvittotyp (idag)",
      salesByReceiptTypeOnDate: "Kundomsättning per kvittotyp ({{date}})",
      noDataToday: "Ingen data för idag ännu",
      noDataOnDate: "Ingen data för {{date}} ännu",
    },
    paymentProvider: {
      SOFTPAY: "Softpay",
      WESTPAY: "Westpay",
      MARKETPAY: "Market Pay",
      VIVA: "Viva",
      NETS: "Nets",
    },
    paymentCategory: {
      CARD: "Kort",
      SWISH: "Swish",
    },
    paymentMethodType: {
      CASH: "Kontant",
      SWISH_COMPANY: "Swish Företag",
      SWISH_COMMERCE: "Swish Handel",
      NETS_MOCK: "Nets Mock",
      NETS_TERMINAL: "Nets Terminal",
      WESTPAY_CLOUD: "Westpay Cloud",
      VIVA: "Viva",
      VIVA_CLOUD: "Viva Cloud",
      VIVA_SMART_CHECKOUT: "Viva Smart Checkout",
      SOFTPAY: "Softpay",
      CREDIT_NOTE: "Kreditnota",
      GIFT_CARD: "Presentkort",
      OTHER: "Övrigt",
      INVOICE: "Faktura",
      ORDER: "Beställning",
      MARKETPAY_CLOUD: "Marketpay Cloud",
      MARKETPAY_LOCAL: "Marketpay Local",
    },
    import: {
      dropZoneHint: "Släpp CSV-filen här",
      csvFileLabel: "CSV-fil *",
      selectedFileKb: "Vald: {{name}} ({{size}} KB)",
      dropFileHint: "Du kan också dra och släppa en CSV var som helst på sidan.",
      sectionAdvancedOptionsSummary: "Fler alternativ (valfritt)",
      optionsSkipFirstRow: "Hoppa över första raden",
      optionsSkipFirstRowToggle: "Hoppa över första raden",
      optionsEncoding: "Teckenkodning",
      optionsDelimiter: "Avgränsare",
      encodingUtf8: "UTF-8",
      encodingLatin1: "Latin-1",
      delimiterComma: "Komma (,)",
      delimiterSemicolon: "Semikolon (;)",
    },
    productImport: {
      title: "Importera produkter",
      pageDescription:
        "Ladda upp en CSV, mappa kolumner och kör en testimport. Rader kopplas till befintliga produkter via Kassaro-ID, sedan artikelnummer, sedan streckkod. Stora importer kan fortsätta i bakgrunden.",
      sectionUploadTitle: "1. Fil och CSV-format",
      sectionUploadDescription:
        "Välj din CSV-fil. Teckenkodning (UTF-8 eller Latin-1) och kolumnavgränsare upptäcks automatiskt. Öppna Fler alternativ om du behöver ändra det eller annat importbeteende.",
      sectionMatchExplanation:
        "Varje rad matchas mot en befintlig produkt med de fält du aktiverar under Fler alternativ. Standard är Kassaro-produkt-ID, sedan artikelnummer, sedan streckkod. Vid träff uppdateras produkten; annars skapas en ny.",
      sectionAdvancedOptionsIntro:
        "Justera teckenkodning eller avgränsare om den automatiska avläsningen blir fel—med en fil vald uppdateras förhandsvisningen direkt när du ändrar. Du kan också styra om första raden är rubriker, om nya produkter får skapas och vilka fält som identifierar en befintlig produkt eller variant.",
      sectionMappingTitle: "2. Mappa kolumner",
      sectionMappingDescription:
        "Koppla varje kolumn i filen till ett produktfält, eller välj Hoppa över. Extra fält från butiken visas längst ner i varje lista.",
      mapAtLeastOneHint:
        "Mappa minst en kolumn till ett produktfält för att låsa upp steget med testimport.",
      mappingTableSourceColumn: "Kolumn i filen",
      mappingTableTargetField: "Produktfält",
      extraFieldLabel: "Extra fält: {{name}}",
      sectionActionsTitle: "3. Testa och importera",
      sectionActionsDescription:
        "Kör först en testimport: inget sparas, men du ser en förhandsvisning och eventuella radfel. När testet lyckas kan du importera på riktigt.",
      runDryRun: "Kör testimport",
      running: "Kör...",
      parseCsvFailed: "Kunde inte läsa CSV: {{message}}",
      selectCsvFile: "Välj en CSV-fil",
      noCsvHeaders: "Inga kolumnrubriker hittades i CSV-filen",
      dryRunFailed: "Testimport misslyckades",
      failedRunDryRun: "Kunde inte köra testimport",
      runDryRunFirst: "Kör en testimport först",
      importFailed: "Kunde inte importera produkter",
      importStartedTracking: "Import startad! Följer förloppet...",
      dryRunCompletedReview: "Testimporten lyckades. Granska resultatet nedan.",
      productsImportedSuccess: "Produkter importerades!",
      columnField: {
        SKIP: "Hoppa över",
        ID: "Produkt-ID (Kassaro ID från export)",
        NAME: "Produktnamn",
        ARTICLE_NUMBER: "Artikelnummer",
        BARCODE: "Streckkod",
        MANUFACTURER_ARTICLE_NUMBER: "Tillverkarens artikelnummer",
        MANUFACTURER_BARCODE: "Tillverkarens streckkod",
        INFORMATION: "Information",
        UNIT_PRICE: "Enhetspris (utpris)",
        VAT: "Moms",
        GROUP_ID: "Varugrupp-ID (Kassaro ID från export)",
        GROUP_NAME: "Varugruppnamn",
        SUPPLIER: "Leverantör",
        SUPPLIER_ID: "Leverantörs-ID",
        UNIT: "Enhet",
        UNIT_ID: "Enhets-ID (Kassaro ID från export)",
        PRODUCT_SYNC_ENABLED: "Produktsynk aktiverad",
        BOOKKEEPING_ACCOUNT_ID: "Bokföringskonto-ID (Kassaro ID från export)",
        BOOKKEEPING_ACCOUNT_NUMBER: "Bokföringskonto",
        STOCK_COUNT: "Lagerantal",
        STOCK_POLICY: "Lagerregel (namn)",
        STOCK_MIN: "Minsta antal i lager",
        STOCK_MAX: "Fyll upp lager till",
        PURCHASE_PRICE: "Inköpspris (inpris)",
        TAKEAWAY_VAT: "Avhämtningsmoms",
        TAKEAWAY_PRICE: "Avhämtningspris",
        TAKEAWAY_BOOKKEEPING_ACCOUNT_ID: "Bokföringskonto-ID för avhämtning",
        TAKEAWAY_BOOKKEEPING_ACCOUNT_NUMBER: "Bokföringskontonummer för avhämtning",
        VARIANT_ID: "Variant-ID",
      },
      variantsSectionTitle: "Variantimport",
      variantsVariantIdOptionalHint:
        "Variant-ID är valfritt. Om det saknas skapas ID automatiskt för varje variantrad.",
      variantsHelpRestaurant:
        "Välj en gruppkolumn nedan. Rader med samma värde blir en produkt. Första raden är huvudprodukten; följande rader blir varianter.",
      variantsHelpRetail:
        "Välj en gruppkolumn nedan. Rader med samma värde blir en produkt. Varje rad i gruppen blir en variant, inklusive den första.",
      variantGroupColumnLabel: "Gruppera varianter efter",
      variantGroupColumnPlaceholder: "Ingen",
      variantGroupColumnOption: "{{sourceColumn}} → {{targetField}}",
      variantGroupColumnHelp:
        "Valfritt. Rader med samma värde i detta fält grupperas till en produkt.",
      variantGroupColumnRequired:
        "Välj en kolumn att gruppera varianter efter.",
      firstRowAsVariantLabel: "Första raden är också en variant",
      firstRowAsVariantToggle: "Inkludera första raden i varje grupp som en variant",
      firstRowAsVariantHelpRestaurant:
        "Första raden definierar endast huvudprodukten. Använd detta för restaurangmenyer där varianter är tillval eller storlekar utöver en basprodukt.",
      firstRowAsVariantHelpRetail:
        "Första raden definierar huvudprodukten och räknas som en variant. Använd detta för detaljhandel där varje storlek eller alternativ är en egen variantrad.",
      delimiterTab: "Tabb",
      delimiterPipe: "Vertikalstreck (|)",
      optionsOnlyUpdate: "Uppdatera endast befintliga produkter (skapa inga nya)",
      optionsOnlyUpdateToggle: "Uppdatera endast befintliga produkter (skapa inga nya)",
      optionsAddStock: "Addera till befintligt lager",
      optionsAddStockToggle: "Addera importerat lager till nuvarande saldo i stället för att ersätta det",
      optionsAddStockHelp:
        "När produkten redan finns adderas importerat lager till aktuellt antal. Nya produkter får det importerade lagret som startvärde, om inte endast-uppdatera är på.",
      matchFieldsLabel: "Matcha befintliga produkter med",
      matchFieldsHelp:
        "Används i denna ordning när en produkt eller variant i butiken slås upp. Stäng av ett fält för att hoppa över det. Extra fält och variant-ID gäller vid variantimport.",
      matchFieldId: "Kassaro-ID",
      matchFieldArticleNumber: "Artikelnummer",
      matchFieldBarcode: "Streckkod",
      matchFieldVariantId: "Variant-ID",
      matchFieldExtraFields: "Extra fält (alla måste stämma)",
      dryRunResultsTitle: "Resultat av testimport",
      dryRunResultsDescription:
        "Granska antal och exempelrader nedan. Åtgärda fel i filen eller mappningen och kör testimporten igen innan du importerar.",
      dryRunSuccessNoErrors:
        "Testimporten lyckades utan fel. Du kan nu fortsätta med importen.",
      importProducts: "Importera produkter",
      importing: "Importerar...",
      metaTotalRows: "Produkter totalt",
      metaValidRows: "Giltiga produkter",
      metaErrors: "Fel",
      metaStatus: "Status",
      metaSuccess: "Lyckades",
      metaFailed: "Misslyckades",
      errorsFoundOne: "Hittade 1 fel. Åtgärda felen innan du importerar.",
      errorsFoundMany: "Hittade {{count}} fel. Åtgärda felen innan du importerar.",
      errorsTitle: "Fel ({{count}})",
      tableRow: "Rad",
      tableField: "Fält",
      tableMessage: "Meddelande",
      tableValue: "Värde",
      validProductsPreview: "Förhandsvisning av giltiga produkter",
      validName: "Namn",
      validGroup: "Grupp",
      validArticleNumber: "Artikelnummer",
      validBarcode: "Streckkod",
      validUnitPrice: "Enhetspris",
      validPurchasePrice: "Inköpspris",
      validVat: "Moms",
      validStock: "Lager",
      validBookkeepingAccount: "Bokföringskonto",
      validVariants: "Varianter",
      validVariantRow: "↳ {{name}}",
      validVariantStock: "lager {{count}}",
      validTakeawayTax: "Avhämtningsmoms",
      validTakeawayPrice: "Avhämtningspris",
      validTakeawayBookkeepingAccount: "Bokföringskonto (avhämtning)",
      validExtraProductFields: "Extra produktfält",
      progressTitle: "Importförlopp",
      progressDescription:
        "Stora importer fortsätter på servern. Du kan navigera bort; förloppet uppdateras när du kommer tillbaka.",
      progressLoadingDescription: "Hämtar importjobb…",
      statusPending: "Väntar",
      statusProcessing: "Bearbetar",
      statusCompleted: "Klar",
      statusFailed: "Misslyckades",
      productsProcessed: "{{processed}} / {{total}} produkter bearbetade",
      succeeded: "{{count}} lyckades",
      failedRows: "{{count}} misslyckades",
      jobQueued: "Importjobben är i kö och startar snart...",
      importCompletedSuccess: "Importen slutfördes!",
      productsImportedCount: "{{count}} produkter importerade",
      importFailedShort: "Importen misslyckades.",
      jobHistoryTitle: "Senaste importjobb",
      jobHistoryDescription: "De senaste bakgrundsimportjobben för den här butiken.",
      jobHistoryStatus: "Status",
      jobHistoryProgress: "Förlopp",
      jobHistoryStarted: "Startad",
      jobHistoryCompleted: "Slutförd",
      jobSucceeded: "{{count}} lyckades",
      skippedChainRows: "{{count}} hoppades över (hanteras av kedjans katalog)",
      chainImportInfo:
        "Produkterna importeras till kedjans katalog. Nya produktgrupper, leverantörer och bokföringskonton skapas i kedjan och allt synkas till alla butiker.",
      storeImportScopedInfo:
        "Produkterna importeras endast till den här butiken. Rader som matchar produkter från kedjans katalog hoppas över, och nya grupper, leverantörer eller bokföringskonton kan bara skapas om kedjan tillåter lokala objekt.",
      storeImportLocked:
        "Produktimport hanteras av kedjan för den här butiken. Importera produkter från kedjans katalog i stället.",
    },
    giftcardImport: {
      title: "Importera presentkort",
      sectionUploadTitle: "1. Fil och CSV-format",
      sectionUploadDescription:
        "Välj din CSV-fil. Teckenkodning (UTF-8 kontra Latin-1) och kolumnavgränsare upptäcks automatiskt. Öppna Fler alternativ om du behöver ändra dem eller annat importbeteende.",
      sectionMatchExplanation:
        "Varje rad matchas mot ett befintligt presentkort via Kassaro-ID, sedan kortnummer. Vid träff uppdateras presentkortet; annars skapas ett nytt (om inte endast uppdatering är på).",
      sectionAdvancedOptionsIntro:
        "Åsidosätt kodning eller avgränsare om automatisk detektering är fel—när en fil är vald uppdateras förhandsvisningen när du ändrar. Du kan också välja om första raden är rubrik och om endast befintliga presentkort får uppdateras.",
      sectionMappingTitle: "2. Mappa kolumner",
      sectionMappingDescription:
        "Matcha varje kolumn från filen mot ett presentkortsfält, eller välj Hoppa över.",
      mapAtLeastOneHint: "Mappa minst en kolumn till ett presentkortsfält för att låsa upp testimporten.",
      mappingTableSourceColumn: "Kolumn i filen",
      mappingTableTargetField: "Presentkortsfält",
      sectionActionsTitle: "3. Testa, sedan importera",
      sectionActionsDescription:
        "Kör ett torrkörningsförst: inget sparas, men du ser förhandsvisning och radfel. När testet lyckas, använd Importera presentkort för att verkställa.",
      runDryRun: "Kör torrkörning",
      running: "Kör...",
      parseCsvFailed: "Kunde inte tolka CSV: {{message}}",
      selectCsvFile: "Välj en CSV-fil",
      noCsvHeaders: "Inga CSV-rubriker hittades",
      dryRunFailed: "Torrkörningen misslyckades",
      failedRunDryRun: "Kunde inte köra torrkörning",
      runDryRunFirst: "Kör en torrkörning först",
      importFailed: "Import av presentkort misslyckades",
      dryRunCompletedReview: "Torrkörningen lyckades. Granska resultaten nedan.",
      columnField: {
        SKIP: "Hoppa över",
        ID: "Kassaro presentkorts-ID",
        CARD_NUMBER: "Kortnummer",
        INITIAL_AMOUNT: "Startbelopp",
        REMAINING_AMOUNT: "Kvarvarande belopp",
        VALID_UNTIL: "Giltigt till",
        STATUS: "Status",
      },
      optionsOnlyUpdate: "Uppdatera endast befintliga presentkort (skapa inga nya)",
      optionsOnlyUpdateToggle: "Uppdatera endast befintliga presentkort (skapa inga nya)",
      dryRunResultsTitle: "Resultat torrkörning",
      dryRunResultsDescription:
        "Granska antal och exempelrader nedan. Åtgärda fel i filen eller mappningen och kör torrkörning igen innan import.",
      dryRunSuccessNoErrors:
        "Torrkörningen slutfördes utan fel. Du kan fortsätta med importen.",
      importGiftcards: "Importera presentkort",
      importing: "Importerar...",
      metaTotalRows: "Rader totalt",
      metaValidRows: "Giltiga rader",
      metaErrors: "Fel",
      metaStatus: "Status",
      metaSuccess: "Lyckades",
      metaFailed: "Misslyckades",
      errorsFoundOne: "Hittade 1 fel. Åtgärda felen innan import.",
      errorsFoundMany: "Hittade {{count}} fel. Åtgärda felen innan import.",
      errorsTitle: "Fel ({{count}})",
      tableRow: "Rad",
      tableField: "Fält",
      tableMessage: "Meddelande",
      tableValue: "Värde",
      validGiftcardsPreview: "Förhandsvisning giltiga presentkort",
      validCardNumber: "Kortnummer",
      validInitialAmount: "Startbelopp",
      validRemainingAmount: "Kvarvarande belopp",
      validValidUntil: "Giltigt till",
      validStatus: "Status",
      importSuccessSummary:
        "Import klar. Skapade: {{created}}, uppdaterade: {{updated}}, hoppade över: {{skipped}}, misslyckade: {{failed}}.",
    },
    devicesView: {
      title: "Enheter",
      loading: "Laddar enheter...",
      errorLoad: "Fel vid laddning av enheter. Försök igen.",
      errorUpdate: "Fel vid uppdatering av enhet. Försök igen.",
      successUpdated: "Enheten uppdaterades",
      tableName: "Namn",
      tableSerialNumber: "Serienummer",
      tablePlatform: "Plattform",
      tableDeviceModel: "Modell",
      tableOsVersion: "OS-version",
      tableAppVersion: "Appversion",
      tableActive: "Aktiv",
      tableDeviceConfig: "Konfiguration",
      tableLastSeen: "Senast använd",
      tableCreated: "Skapad",
      unnamedDevice: "Namnlös enhet",
      none: "Ingen",
      empty:
        "Inga enheter registrerade ännu. Enheter visas här när de först ansluter till butiken.",
      editTitle: "Redigera enhet: {{name}}",
      tableLicensed: "Licens",
      tableActions: "Åtgärder",
      licensedYes: "Inom gräns",
      licensedNo: "Över gräns",
      pendingClassification: "Behöver klassificeras",
      classifyAction: "Klassificera",
      activateAction: "Aktivera",
      deactivateAction: "Inaktivera",
      classifyTitle: "Klassificera enhet: {{name}}",
      classifyNewDevice: "Ny enhet",
      classifyNewDeviceHint:
        "Ökar antalet licensierade enheter från den dag enheten dök upp.",
      classifyReplacement: "Ersättning",
      classifyReplacementHint:
        "Avaktiverar den ersatta enheten. Antalet licensierade enheter ändras inte.",
      replacementSuggestion:
        "{{name}} slutade synas ungefär samtidigt ({{lastSeen}}), vilket ser ut som en ominstallation.",
      replacedDevice: "Ersatt enhet",
      selectReplacedDevice: "Välj enhet",
      classifyConfirm: "Klassificera",
      licensedSummary: "{{active}} aktiva / {{limit}} licensierade",
      pendingClassificationCount_one: "{{count}} behöver klassificeras",
      pendingClassificationCount_other: "{{count}} behöver klassificeras",
    },
    printersView: {
      title: "Skrivare",
      loading: "Laddar skrivare...",
      createPrinter: "Skapa skrivare",
      errorLoad: "Fel vid laddning av skrivare. Försök igen.",
      errorCreate: "Fel vid skapande av skrivare. Försök igen.",
      errorUpdate: "Fel vid uppdatering av skrivare. Försök igen.",
      errorDelete: "Fel vid borttagning av skrivare. Försök igen.",
      successCreated: "Skrivaren skapades",
      successUpdated: "Skrivaren uppdaterades",
      successDeleted: "Skrivaren togs bort",
      deleteConfirm: "Är du säker på att du vill ta bort denna skrivare?",
      empty: "Inga skrivare ännu. Skapa en för att komma igång.",
    },
    usersView: {
      title: "Användare",
      loading: "Laddar användare...",
      addUser: "Lägg till användare",
      errorLoad: "Fel vid laddning av användare. Försök igen.",
      errorRemove: "Fel vid borttagning av åtkomst. Försök igen.",
      successAdded: "Användaren lades till",
      successRemoved: "Åtkomst togs bort",
      successPermissionGroupUpdated: "Behörighetsgruppen uppdaterades",
      removeConfirm: "Är du säker på att du vill ta bort åtkomst för {{email}}?",
      tableEmail: "E-post",
      tableName: "Namn",
      tableRole: "Roll",
      tableAccess: "Åtkomst",
      accessChain: "Kedja",
      accessStore: "Butik",
      tablePermissionGroup: "Behörighetsgrupp",
      tableCreated: "Skapad",
      tableActions: "Åtgärder",
      remove: "Ta bort",
      empty: "Inga användare hittades.",
      panelAddTitle: "Lägg till användare",
      thisUser: "denna användare",
      selectPermissionGroup: "Välj behörighetsgrupp",
      errorPermissionGroupUpdate: "Fel vid uppdatering av behörighetsgrupp. Försök igen.",
      changePassword: "Byt lösenord",
      panelChangePasswordTitle: "Byt lösenord",
      successPasswordChanged: "Lösenordet ändrades",
    },
    changePasswordForm: {
      description:
        "Ange ett nytt lösenord för {{email}}. Användaren loggas ut på alla enheter och måste logga in igen med det nya lösenordet.",
      passwordLabel: "Nytt lösenord *",
      passwordPlaceholder: "Ange nytt lösenord",
      passwordRequired: "Lösenord krävs",
      passwordMinLength: "Lösenordet måste vara minst 6 tecken",
      confirmLabel: "Bekräfta lösenord *",
      confirmPlaceholder: "Ange lösenordet igen",
      confirmMismatch: "Lösenorden matchar inte",
      errorChange: "Kunde inte byta lösenord. Försök igen.",
      saving: "Sparar...",
      save: "Byt lösenord",
    },
    paymentMethodsView: {
      create: "Ny betalningsmetod",
      selectType: "Välj betalningsmetodtyp",
      title: "Betalmetoder",
      loading: "Laddar betalmetoder...",
      errorLoad: "Kunde inte ladda betalmetoder.",
      empty: "Inga betalmetoder hittades.",
      tableName: "Namn",
      tableType: "Typ",
    },
    paymentMethodForm: {
      newPaymentMethod: "Ny betalningsmetod",
      createdSuccessfully: "Betalningsmetod skapad",
      invalidType: "Okänd betalningsmetodtyp.",
      editPaymentMethod: "Redigera betalningsmetod",
      loading: "Laddar betalningsmetod...",
      errorLoad: "Kunde inte ladda betalningsmetod.",
      updatedSuccessfully: "Betalningsmetod uppdaterad",
      deletePaymentMethod: "Radera betalningsmetod",
      deleteConfirmationMessage:
        'Är du säker på att du vill radera "{{name}}"? Denna åtgärd kan inte ångras.',
      basicInformation: "Grundinformation",
      additionalSettings: "Ytterligare inställningar",
      name: "Namn",
      type: "Typ",
      bookkeepingAccount: "Bokföringskonto",
      defaultAccount: "Förvalt",
      color: "Färg",
      clearColor: "Ta bort färg",
      openCashDrawer: "Öppna kontantlåda efter försäljning",
      useChangeCalculator: "Använd växelkalkylator",
      askForAmount: "Fråga om belopp vid betalning",
      integration: "Integration",
      integrationRequired: "Integration krävs",
      selectIntegration: "Välj integration",
      noIntegration: "Ingen – endast underlag",
      emailDocumentToStore: "Skicka underlag till butikens rapport-e-post",
      terminalId: "Terminal-ID",
      noneSelected: "Inget valt",
      documentHeaderTextPlaceholder: "t.ex. butiksnamn",
      customerSecondaryField: "Kundlista rad två",
      customerThirdField: "Kundlista rad tre",
      printSignatureReceipt: "Skriv ut signaturkvitto",
      customerDisplayField: {
        YOUR_REFERENCE: "Er referens",
        OUR_REFERENCE: "Vår referens",
        ORG_NUMBER: "Organisationsnummer",
        EMAIL: "E-post",
        PHONE: "Telefon",
        CITY: "Stad",
        ADDRESS1: "Adress",
        CUSTOMER_NUMBER: "Kundnummer",
      },
      marketPay: {
        ipAddress: "IP-adress",
        ipAddressRequired: "IP-adress krävs",
      },
      westpay: {
        connectionId: "Anslutnings-ID",
        tipOnScreen: "Dricks på kunddisplay",
      },
      swish: {
        additionalSettings: "Ytterligare inställningar",
        swishNumber: "Swish-nummer",
        messageToCustomer: "Meddelande till kund",
        technicalSupplierInfo:
          "Välj {{companyName}} ({{orgNumber}}) som teknisk leverantör vid uppsättning av Swish Handel-avtal.",
      },
      invoice: {
        paymentDuration: "Betalningstid (dagar)",
        paymentDurationPlaceholder: "Ange antal dagar",
        paymentDurationRequired: "Betalningstiden kan inte tas bort när den är satt",
        paymentDurationInvalid: "Ange ett heltal antal dagar större än 0",
        documentHeaderText: "Text på fakturan",
      },
      order: {
        documentHeaderText: "Text på ordern",
        includeOrderDate: "Inkludera datum på ordern",
      },
      softpay: {
        softpayStore: "Softpay-butik",
      },
      viva: {
        adminOnly: "Endast admin",
        multiMerchantId: "Multi merchant-ID",
        viewTransactions: "Visa transaktioner",
      },
    },
    vivaTransactionsView: {
      title: "Viva-transaktioner – {{name}}",
      breadcrumb: "Transaktioner",
      refresh: "Uppdatera",
      fromDate: "Från datum",
      search: "Sök",
      summary: "{{count}} transaktioner för merchant {{merchantId}} från {{fromDate}} bakåt till {{toDate}}",
      loading: "Laddar transaktioner från Viva...",
      loadingMore: "Laddar äldre transaktioner...",
      scrollForMore: "Scrolla för att ladda äldre transaktioner",
      limitReached: "Visar som mest {{days}} dagar bakåt. Välj ett tidigare från-datum för att gå längre.",
      errorLoad: "Kunde inte ladda transaktioner från Viva: {{message}}",
      empty: "Inga transaktioner hittades.",
      tableTime: "Tid",
      tableTransactionId: "Transaktions-ID",
      tableOrderCode: "Ordernummer",
      tableAmount: "Belopp",
      tableStatus: "Status",
      tableType: "Typ",
      tableMerchantReference: "Merchant-referens",
      tableSourceCode: "Källkod",
      tableCard: "Kort",
      panelTitle: "Transaktion {{id}}",
    },
    integrationsView: {
      title: "Integrationer",
      loading: "Laddar integrationer...",
      create: "Skapa integration",
      errorLoad: "Fel vid laddning av integrationer. Försök igen.",
      errorUpdate: "Fel vid uppdatering av integration. Försök igen.",
      successCreated: "Integrationen skapades",
      successUpdated: "Integrationen uppdaterades",
      successDeleted: "Integrationen togs bort",
      deleteConfirm: "Är du säker på att du vill ta bort denna integration?",
      empty: "Inga integrationer ännu. Skapa en för att komma igång.",
      tableType: "Typ",
      tableName: "Namn",
      tableCreated: "Skapad",
      tableUpdated: "Uppdaterad",
      tableActions: "Åtgärder",
      delete: "Ta bort",
      panelCreate: "Skapa integration",
      panelEdit: "Redigera integration: {{name}}",
      noAvailableTypes:
        "Inga integrationstyper är tillgängliga för butikens aktuella paketfunktioner och betalterminaler.",
      type: {
        WESTPAY_CLOUD: "Westpay Cloud",
        VIVA: "Viva",
        ELAVON: "Elavon",
        PAYTRIM: "Paytrim",
        SOFTPAY: "SoftPay",
        NETS: "Nets",
        MARKETPAY: "MarketPay",
        FORTNOX: "Fortnox",
        SPIRIS: "Spiris",
        SHOPIFY: "Shopify",
        PERSONALKOLLEN: "Personalkollen",
      },
    },
    shopifyIntegrationForm: {
      summary:
        "Skapa en anpassad Shopify-app i Partner Dashboard, spara uppgifterna här och anslut sedan butiken.",
      guideLink: "Öppna guide för Partner Dashboard",
      provisionTitle: "1. Spara appuppgifter",
      connectTitle: "2. Anslut butik",
      saveCredentials: "Spara uppgifter",
      provisionSaved: "Uppgifter sparade.",
      connect: "Anslut Shopify",
      reconnect: "Anslut Shopify igen",
      readyToConnect:
        "Uppgifterna är sparade. Klicka på Anslut Shopify för att slutföra auktoriseringen.",
      notProvisioned:
        "Spara Partner-appens uppgifter först, eller kontakta Kassaro support.",
      oauthError: "Kunde inte starta Shopify-anslutningen. Försök igen.",
      statusTitle: "Status",
      statusLine: "Etablerad: {{provisioned}} · Ansluten: {{connected}}",
    },
    productsView: {
      overlayLoadFailed: "Kunde inte ladda butikens anpassningar av kedjeprodukter. Ladda om sidan för att försöka igen.",
      title: "Produkter",
      loading: "Laddar produkter...",
      import: "Importera",
      create: "Skapa produkt",
      panelStockSaveFailed:
        "Produkten sparades, men lagret kunde inte sparas. Försök igen.",
      errorLoad: "Fel vid laddning av produkter. Försök igen.",
      errorSave: "Fel vid sparande av produkt. Försök igen.",
      successCreated: "Produkten skapades",
      successUpdated: "Produkten uppdaterades",
      successDeleted: "Produkten togs bort",
      deleteConfirm: "Är du säker på att du vill ta bort denna produkt?",
      empty: "Inga produkter ännu.",
      emptyHint: "Skapa en eller importera en CSV-fil för att komma igång.",
      tableName: "Namn",
      tableArticleNumber: "Artikelnummer",
      tableUnitPrice: "À-pris",
      tableVat: "Moms %",
      tableType: "Typ",
      tableUpdated: "Uppdaterad",
      tableActions: "Åtgärder",
      delete: "Ta bort",
      panelCreate: "Skapa produkt",
      panelEdit: "Redigera produkt: {{name}}",
      tableGroup: "Varugrupp",
      tableStock: "Lager",
      tableBookkeepingCostcenter: "Kostnadsställe",
      bookkeepingDefault: "Standard",
      columns: "Kolumner",
      filters: "Filter",
      filterAll: "Alla",
      filterStockHas: "Har lagervärde",
      filterStockNone: "Inget lagervärde",
      filterBookkeepingDefault: "Standard (ej angivet)",
      searchPlaceholder: "Sök produkter...",
      totalCount: "{{count}} produkter",
      saveChanges: "Spara ändringar ({{count}})",
      showVariants: "Visa varianter ({{count}})",
      basePrice: "Grundpris {{price}}. Varianter utan eget pris använder det. Klicka för att ändra.",
      clearFilters: "Rensa filter",
      filterStockWarning: "Lagerbevakning",
      filterStockWarningOut: "Slut i lager",
      filterStockWarningLow: "Under minsta antal",
      filterVariants: "Varianter",
      filterVariantsHas: "Med varianter",
      filterVariantsNone: "Utan varianter",
      filterSupplier: "Leverantör",
      filterNone: "Ingen",
      filterUpdated: "Ändrad",
      filterUpdatedWithin: "Senaste {{count}} dagarna",
      filterPrice: "Pris (produkt eller variant)",
      filterPriceFrom: "Från",
      filterPriceTo: "Till",
      filterChipSupplier: "Leverantör: {{value}}",
      filterChipUnit: "Enhet: {{value}}",
      filterChipUpdated: "Ändrad: {{value}}",
      filterChipPrice: "Pris: {{value}}",
      filterChipPriceMin: "Pris: från {{value}}",
      filterChipPriceMax: "Pris: till {{value}}",
      hideVariants: "Dölj varianter",
      stockAtProduct: "Produktens lagersaldo",
      stockLocation: "Lagerplats som visas i kolumnen Lager",
      stockSaveFailed: "Lagersaldon kunde inte sparas: {{error}}",
      sync: "Synka",
      syncHint: "Synka ändringar · Shift-klicka för full omladdning",
      filterChipSearch: 'Sök: "{{value}}"',
      filterChipGroup: "Grupp: {{value}}",
      filterChipVat: "Moms: {{value}}",
      filterChipStockHas: "Har lagervärde",
      filterChipStockNone: "Inget lagervärde",
      filterChipBookkeeping: "Bokföring: {{value}}",
      filterChipType: "Typ: {{value}}",
      statusSyncing: "Synkar…",
      statusSyncingFull: "Laddar produkter… {{count, number}} hämtade",
      statusSyncingIncremental: "Synkar uppdateringar… {{count, number}} hämtade",
      loadingFull: "Laddar produkter… {{count, number}} hämtade hittills",
      loadingIncremental: "Söker uppdateringar… {{count, number}} hämtade hittills",
      statusError: "Synkning misslyckades",
      statusSynced: "Synkad — {{count}} produkter laddade · {{time}}",
      bulkSelected: "{{count}} markerade",
      bulkValuePlaceholder: "Värde",
      bulkApply: "Tillämpa på markerade",
      bulkDelete: "Radera markerade",
      bulkDeleteConfirm: "Radera {{count}} markerade produkt(er)?",
      bulkClear: "Avmarkera",
      bulkFailed: "{{count}} produkt(er) kunde inte sparas.",
      chainSaveTarget: "Spara ändringar för",
      chainSaveTargetChain: "Hela kedjan",
      chainSaveTargetStore: "Bara den här butiken",
      chainSaveTargetLocked: "Spara eller ångra ändringarna först",
      overlayStoreValue: "Anpassad · Kedjan: {{value}}",
      overlayChainValue: "Anpassad i butiken: {{value}}",
      overlayReset: "Använd kedjans värde",
      panelOverlaySaveFailed: "Ändringarna kunde inte sparas i denna butik: {{error}}",
    },
    productForm: {
      name: "Namn",
      articleNumber: "Artikelnummer",
      productGroup: "Varugrupp",
      none: "Ingen",
      unit: "Enhet",
      unitSearchPlaceholder: "Sök enheter...",
      course: "Servering",
      prepStation: "Bongplats",
      productType: "Produkttyp",
      typePRODUCT: "Produkt",
      typeSERVICE: "Tjänst",
      typeGIFT_CARD: "Presentkort",
      typeTEXT: "Text",
      unitPrice: "À-pris",
      vat: "Moms (%)",
      description: "Beskrivning",
      information: "Information",
      stockCount: "Lagersaldo",
      barcodeCode: "Streckkod",
      barcodeType: "Streckkodstyp",
      barcodeFormatId: "Streckkodsformat",
      openPrice: "Öppet pris",
      serialTracking: "Serienummer",
      requireReference: "Kräv referens",
      updatedAt: "Senast uppdaterad",
      manufacturerArticleNumber: "Tillverkarens artikelnummer",
      manufacturerBarcode: "Tillverkarens streckkod",
      purchasePrice: "Inköpspris",
      bookkeepingAccountId: "Bokföringskonto",
      bookkeepingAccountIdPlaceholder: "Konto-ID (valfritt)",
      takeawayVat: "Avhämtning moms (%)",
      takeawayBookkeepingAccount: "Avhämtning bokföringskonto",
      takeawayPrice: "Avhämtningspris",
      notSet: "Ej angivet",
      deleteProduct: "Ta bort produkt",
      variantsTable: {
        price: "Pris",
        codes: "Koder",
        stock: "Lager",
        policy: "Lagerregel",
        allVariants: "Alla varianter",
        varies: "Olika",
        variant: "Variant",
        thisStore: "Den här butiken",
        noPolicy: "Ingen lagerregel",
        customLevels: "Egna nivåer",
        min: "Minsta antal",
        max: "Fyll upp till",
        manage: "Hantera varianter",
        remove: "Ta bort variant",
        empty: "Inga varianter",
        hint: "Tomma fält ärver produktens värde. Ändringar i raden Alla varianter gäller alla varianter.",
      },
      variantOptions: {
        title: "Variantalternativ",
        dimensions: "Dimensioner",
        dimensionsHint: "Välj vad varianterna skiljer sig åt i (max {{max}})",
        productName: "Produktnamn",
        existingVariantsValue: "{{fieldName}} för befintliga varianter",
        existingVariantsValuePlaceholder:
          "Lämna tomt för att behålla dem under övriga varianter",
        renameValue: "Byt namn på värde",
        removeValue: "Ta bort värde",
        newValue: "Nytt värde",
        newValuePlaceholder: "T.ex. Röd eller XL",
        addValue: "Lägg till",
        selectedCount: "Varianter ({{count}})",
        new: "Ny",
        skipped: "Skapas inte",
        existing: "Befintlig",
        willBeRemoved: "Tas bort",
        otherVariants: "Övriga varianter",
        otherVariantsHint:
          "Dessa varianter saknar värde för någon av dimensionerna och behålls som de är.",
        generateBarcodes: "Generera streckkoder för nya varianter",
        generateBarcodesFailed: "Kunde inte generera streckkoder. Försök igen.",
        apply: "Använd",
        removeTitle: "Ta bort varianter?",
        removeMessage_one: "1 variant tas bort när du sparar produkten.",
        removeMessage_other:
          "{{count}} varianter tas bort när du sparar produkten.",
        removeWithStockMessage_one:
          "1 variant tas bort när du sparar produkten. Den har lagersaldo.",
        removeWithStockMessage_other:
          "{{count}} varianter tas bort när du sparar produkten. Några av dem har lagersaldo.",
      },
      sections: {
        noticeTitle: "Innan du sparar",
        basicInformationTitle: "Grundläggande information",
        basicInformationDescription: "Namn, pris, moms och försäljning.",
        restaurantTitle: "Restaurang",
        informationTitle: "Information",
        informationDescription: "Text i produktens inforuta i kassan.",
        retailTitle: "Detaljhandel",
        retailDescription: "Streckkod, lager, artikelnummer och inköpspris.",
        extraTitle: "Extra fält",
        extraDescription: "Butiksspecifika fält för denna plats.",
        variantsTitle: "Varianter",
        modifiersTitle: "Tillval",
        bookkeepingTitle: "Bokföring",
        bookkeepingDescription: "Produkttyp och försäljningskonto.",
        takeawayTitle: "Avhämtning",
        dangerTitle: "Farlig zon",
        metaTitle: "Post",
        metaDescription: "Skrivskyddade tidsstämplar för produkten.",
      },
    },
    productGroupForm: {
      inheritanceIntro:
        "Värden som anges här ärvs av produkter i gruppen. En produkt kan inte ändra ett fält som gruppen redan definierar.",
      noUnits: "Inga enheter ännu.",
      createUnit: "Skapa en enhet",
      noModifiers: "Inga tillval i kedjan ännu.",
      productSyncEnabled: "Extern produktsynk",
      includeMainProductAsVariant: "Inkludera huvudprodukt som variant",
      variantSelectionMode: "Variantval",
      variantSelectionModeALWAYS_PROMPT: "Fråga alltid om variant",
      variantSelectionModeDEFAULT_ON_PRESS:
        "Lägg till standard vid tryck, välj variant vid långtryck",
      modifierGroups: "Tillvalsgrupper",
      modifiers: "Tillval",
      alwaysAppliedModifiers: "Alltid tillämpade tillval",
      deleteGroup: "Radera grupp",
    },
    productGroupsView: {
      title: "Varugrupper",
      loading: "Laddar varugrupper...",
      create: "Skapa varugrupp",
      errorLoad: "Fel vid laddning av varugrupper. Försök igen.",
      errorSave: "Fel vid sparande av varugrupp. Försök igen.",
      successCreated: "Varugrupp skapad",
      successUpdated: "Varugrupp sparad",
      successDeleted: "Varugrupp raderad",
      deleteConfirm: 'Är du säker på att du vill radera "{{name}}"?',
      empty: "Inga varugrupper ännu.",
      emptyHint: "Skapa en för att komma igång.",
      tableName: "Namn",
      tableVat: "Moms",
      tableType: "Typ",
      tableUnit: "Enhet",
      panelCreate: "Skapa varugrupp",
    },
    unitForm: {
      basicInformation: "Grundinformation",
      name: "Namn",
      suffix: "Suffix",
      suffixPlaceholder: "t.ex. kg",
      decimals: "Decimaler",
      example: "Exempel:",
      serialScale: "Seriell våg",
      enableSerialScale: "Aktivera seriell våg",
      serialScaleUnit: "Vågenhet",
      serialScaleUnitKILOGRAM: "Kilogram",
      serialScaleUnitHECTOGRAM: "Hektogram",
      serialScaleUnitGRAM: "Gram",
      deleteUnit: "Radera enhet",
    },
    unitsView: {
      title: "Enheter",
      loading: "Laddar enheter...",
      create: "Skapa enhet",
      errorLoad: "Fel vid laddning av enheter. Försök igen.",
      errorSave: "Fel vid sparande av enhet. Försök igen.",
      successCreated: "Enhet skapad",
      successUpdated: "Enhet sparad",
      successDeleted: "Enhet raderad",
      deleteConfirm:
        'Är du säker på att du vill radera "{{name}}"? Produkter som använder den kommer att få sin enhet borttagen.',
      empty: "Inga enheter ännu.",
      emptyHint: "Skapa en för att komma igång.",
      tableName: "Namn",
      tableSuffix: "Suffix",
      tableDecimals: "Decimaler",
      panelCreate: "Skapa enhet",
    },
    supplierForm: {
      basicInformation: "Grundinformation",
      name: "Namn",
      orgNumber: "Organisationsnummer",
      contactPerson: "Kontaktperson",
      contactPhone: "Kontakttelefon",
      contactEmail: "Kontakt-e-post",
      street: "Gata",
      city: "Ort",
      postalcode: "Postnummer",
      country: "Land",
      countryNone: "Ej angivet",
      countryFINLAND: "Finland",
      countrySWEDEN: "Sverige",
      note: "Anteckning",
      deleteSupplier: "Radera leverantör",
    },
    suppliersView: {
      title: "Leverantörer",
      loading: "Laddar leverantörer...",
      create: "Skapa leverantör",
      errorLoad: "Fel vid laddning av leverantörer. Försök igen.",
      errorSave: "Fel vid sparande av leverantör. Försök igen.",
      successCreated: "Leverantör skapad",
      successUpdated: "Leverantör sparad",
      successDeleted: "Leverantör raderad",
      deleteConfirm: 'Är du säker på att du vill radera "{{name}}"?',
      empty: "Inga leverantörer ännu.",
      emptyHint: "Skapa en för att komma igång.",
      tableName: "Namn",
      tableContact: "Kontakt",
      tableCity: "Ort",
      panelCreate: "Skapa leverantör",
    },
    productPageForm: {
      basicInformation: "Grundinformation",
      name: "Namn",
      deleteProductPage: "Radera produktsida",
    },
    productPagesView: {
      title: "Produktsidor",
      loading: "Laddar produktsidor...",
      create: "Skapa produktsida",
      errorLoad: "Fel vid laddning av produktsidor. Försök igen.",
      errorSave: "Fel vid sparande av produktsida. Försök igen.",
      successCreated: "Produktsida skapad",
      successUpdated: "Produktsida sparad",
      successDeleted: "Produktsida raderad",
      deleteConfirm: 'Är du säker på att du vill radera "{{name}}"?',
      empty: "Inga produktsidor ännu.",
      emptyHint: "Hantera produktsidor i POS-layoutredigeraren.",
      tableName: "Namn",
      panelCreate: "Skapa produktsida",
    },
    offerForm: {
      basicInformation: "Grundinformation",
      name: "Namn",
      receiptText: "Kvittotext",
      type: "Typ",
      enabled: "Aktiverad",
      priority: "Prioritet",
      schedule: "Schema",
      useSchedule: "Begränsa med datum och tid",
      startsAt: "Startar",
      endsAt: "Slutar",
      useHours: "Anpassade tider",
      additionalSettings: "Kampanjinställningar",
      products: "Produkter",
      productGroups: "Produktgrupper",
      percentage: "Procent",
      buyQuantity: "Köp antal",
      payQuantity: "Betala för antal",
      quantity: "Antal",
      price: "Pris",
      unitPrice: "Enhetspris",
      takeawayPrice: "Takeaway-pris",
      prices: "Produktpriser",
      slots: "Kombofack",
      addSlot: "Lägg till fack",
      removeSlot: "Ta bort fack",
      slot: "Fack {{number}}",
      deleteOffer: "Radera erbjudande",
      types: {
        PERCENTAGE: "Procent",
        BUY_X_PAY_Y: "Köp X betala Y",
        QUANTITY_PRICE: "Antalspris",
        FIXED_PRICE: "Fast pris",
        COMBO: "Kombo",
      },
      weekdays: {
        monday: "Måndag",
        tuesday: "Tisdag",
        wednesday: "Onsdag",
        thursday: "Torsdag",
        friday: "Fredag",
        saturday: "Lördag",
        sunday: "Söndag",
      },
    },
    offersView: {
      title: "Erbjudanden",
      loading: "Laddar erbjudanden...",
      create: "Skapa erbjudande",
      errorLoad: "Fel vid laddning av erbjudanden. Försök igen.",
      errorSave: "Fel vid sparande av erbjudande. Försök igen.",
      successCreated: "Erbjudande skapat",
      successUpdated: "Erbjudande sparat",
      successDeleted: "Erbjudande raderat",
      deleteConfirm: 'Är du säker på att du vill radera "{{name}}"?',
      empty: "Inga erbjudanden ännu.",
      emptyHint: "Skapa ett för att komma igång.",
      tableName: "Namn",
      tableType: "Typ",
      tableEnabled: "Aktiverad",
      tablePriority: "Prioritet",
      enabledYes: "Ja",
      enabledNo: "Nej",
      panelCreate: "Skapa erbjudande",
    },
    layoutForm: {
      basicInformation: "Grundinformation",
      name: "Namn",
      defaultProductPageId: "Standardproduktsida",
      defaultProductPageNone: "Ingen",
      tabletColumns: "Tablet-kolumner",
      tabletRows: "Tablet-rader",
      mobileColumns: "Mobil-kolumner",
      mobileRows: "Mobil-rader",
      deleteLayout: "Radera layout",
    },
    layoutsView: {
      title: "Layouter",
      loading: "Laddar layouter...",
      create: "Skapa layout",
      errorLoad: "Fel vid laddning av layouter. Försök igen.",
      errorSave: "Fel vid sparande av layout. Försök igen.",
      successCreated: "Layout skapad",
      successUpdated: "Layout sparad",
      successDeleted: "Layout raderad",
      deleteConfirm: 'Är du säker på att du vill radera "{{name}}"?',
      empty: "Inga layouter ännu.",
      emptyHint: "Skapa layouter i POS.",
      tableName: "Namn",
      tableDefaultPage: "Standardsida",
      noDefaultPage: "Ingen",
      panelCreate: "Skapa layout",
    },
    courseForm: {
      basicInformation: "Grundinformation",
      name: "Namn",
      sortOrder: "Sortering",
      deleteCourse: "Radera servering",
    },
    coursesView: {
      title: "Serveringar",
      loading: "Laddar serveringar...",
      create: "Skapa servering",
      errorLoad: "Fel vid laddning av serveringar. Försök igen.",
      errorSave: "Fel vid sparande av servering. Försök igen.",
      successCreated: "Servering skapad",
      successUpdated: "Servering sparad",
      successDeleted: "Servering raderad",
      deleteConfirm: 'Är du säker på att du vill radera "{{name}}"?',
      empty: "Inga serveringar ännu.",
      emptyHint: "Lägg till serveringar för att komma igång.",
      tableName: "Namn",
      tableSortOrder: "Ordning",
      panelCreate: "Skapa servering",
    },
    prepStationForm: {
      basicInformation: "Grundinformation",
      name: "Namn",
      servingScope: "Serveringar på notan",
      servingScopeONLY_THIS: "Endast denna",
      servingScopeALL: "Alla",
      prepStationScope: "Ta med andra bongplatser på notan",
      prepStationScopeONLY_THIS: "Endast denna",
      prepStationScopeALL: "Alla",
      simplifyItemsFromOtherPrepStations:
        "Dölj tillval från andra bongplatser",
      requireReference: "Kräv bongreferens före betalning",
      onePrepTicketPerCourse: "En bong per rätt",
      master: "Spegla bongplatser",
      isMaster: "Spegla bongplatser",
      mirroredPrepStations: "Bongplatser att spegla",
      deletePrepStation: "Radera bongplats",
    },
    prepStationsView: {
      title: "Bongplatser",
      loading: "Laddar bongplatser...",
      create: "Skapa bongplats",
      errorLoad: "Fel vid laddning av bongplatser. Försök igen.",
      errorSave: "Fel vid sparande av bongplats. Försök igen.",
      successCreated: "Bongplats skapad",
      successUpdated: "Bongplats sparad",
      successDeleted: "Bongplats raderad",
      deleteConfirm: 'Är du säker på att du vill radera "{{name}}"?',
      empty: "Inga bongplatser ännu.",
      emptyHint: "Lägg till bongplatser för att komma igång.",
      tableName: "Namn",
      tableScope: "Omfattning",
      tableMaster: "Spegling",
      panelCreate: "Skapa bongplats",
    },
    modifierForm: {
      basicInformation: "Grundinformation",
      name: "Namn",
      price: "Pris",
      internal: "Endast internt (skrivs inte ut på kvitto)",
      maxQuantity: "Max antal per artikel",
      slots: "Platser i tillvalsgrupp",
      deleteModifier: "Radera tillval",
    },
    modifiersView: {
      title: "Tillval",
      loading: "Laddar tillval...",
      create: "Skapa tillval",
      errorLoad: "Fel vid laddning av tillval. Försök igen.",
      errorSave: "Fel vid sparande av tillval. Försök igen.",
      successCreated: "Tillval skapat",
      successUpdated: "Tillval sparat",
      successDeleted: "Tillval raderat",
      deleteConfirm:
        'Är du säker på att du vill radera "{{name}}"? Åtgärden kan inte ångras.',
      empty: "Inga tillval ännu.",
      emptyHint: "Skapa ett för att komma igång.",
      tableName: "Namn",
      tablePrice: "Pris",
      tableVat: "Moms",
      panelCreate: "Skapa tillval",
    },
    modifierGroupForm: {
      basicInformation: "Grundinformation",
      name: "Namn",
      minAmount: "Minsta antal",
      maxAmount: "Största antal",
      minExceedsMax: "Minsta antal får inte vara större än största antal",
      alwaysPrompt: "Fråga alltid vid tillägg",
      modifiers: "Tillval",
      noModifiers: "Inga tillval tillagda",
      createModifier: "Skapa ett tillval",
      deleteModifierGroup: "Radera tillvalsgrupp",
    },
    modifierGroupsView: {
      title: "Tillvalsgrupper",
      loading: "Laddar tillvalsgrupper...",
      create: "Skapa tillvalsgrupp",
      errorLoad: "Fel vid laddning av tillvalsgrupper. Försök igen.",
      errorSave: "Fel vid sparande av tillvalsgrupp. Försök igen.",
      successCreated: "Tillvalsgrupp skapad",
      successUpdated: "Tillvalsgrupp sparad",
      successDeleted: "Tillvalsgrupp raderad",
      deleteConfirm:
        'Är du säker på att du vill radera "{{name}}"? Åtgärden kan inte ångras.',
      empty: "Inga tillvalsgrupper ännu.",
      emptyHint: "Skapa en för att komma igång.",
      tableName: "Namn",
      tableModifiers: "Tillval",
      panelCreate: "Skapa tillvalsgrupp",
    },
    bookkeepingAccountForm: {
      basicInformation: "Grundinformation",
      name: "Kontonamn",
      accountNumber: "Kontonummer",
      deleteAccount: "Radera konto",
    },
    bookkeepingAccountsView: {
      title: "Bokföringskonton",
      loading: "Laddar bokföringskonton...",
      create: "Skapa konto",
      errorLoad: "Fel vid laddning av bokföringskonton. Försök igen.",
      errorSave: "Fel vid sparande av bokföringskonto. Försök igen.",
      successCreated: "Bokföringskonto skapat",
      successUpdated: "Bokföringskonto sparat",
      successDeleted: "Bokföringskonto raderat",
      deleteConfirm:
        'Är du säker på att du vill radera "{{name}}"? Denna åtgärd kan inte ångras.',
      empty: "Inga bokföringskonton ännu.",
      emptyHint: "Skapa ett för att komma igång.",
      tableName: "Namn",
      tableNumber: "Nummer",
      panelCreate: "Skapa konto",
    },
    giftcardsView: {
      title: "Presentkort",
      loading: "Laddar presentkort...",
      import: "Importera",
      create: "Skapa presentkort",
      errorLoad: "Fel vid laddning av presentkort. Försök igen.",
      errorSave: "Fel vid sparande av presentkort. Försök igen.",
      successCreated: "Presentkort skapat",
      successUpdated: "Presentkort uppdaterat",
      successDeleted: "Presentkort borttaget",
      deleteConfirm: "Är du säker på att du vill ta bort detta presentkort?",
      empty: "Inga presentkort ännu.",
      emptyHint: "Skapa ett för att komma igång.",
      tableCardNumber: "Kortnummer",
      tableInitialAmount: "Startbelopp",
      tableRemainingAmount: "Kvarvarande belopp",
      tableValidUntil: "Giltigt till",
      tableCreated: "Skapad",
      tableStore: "Butik",
      tableActions: "Åtgärder",
      delete: "Ta bort",
      panelCreate: "Skapa presentkort",
      panelEdit: "Redigera presentkort: {{number}}",
    },
    storeDebtsView: {
      title: "Skuld mellan butiker",
      loading: "Laddar skuld mellan butiker...",
      errorLoad: "Kunde inte ladda skuld mellan butiker.",
      empty: "Ingen skuld mellan butiker ännu.",
      detailTitle: "Butikspar",
      notFound: "Detta butikspar kunde inte hittas.",
      eventsLoading: "Laddar händelser...",
      eventsError: "Kunde inte ladda händelser.",
      eventsEmpty: "Inga händelser ännu.",
      settleTitle: "Markera som betald",
      nothingToSettle: "Det finns ingen utestående skuld att reglera.",
      store1: "Butik 1",
      store2: "Butik 2",
      debtor: "Skyldig",
      amount: "Belopp",
      settled: "Reglerad",
      owes: "{{debtor}} är skyldig {{creditor}} {{amount}}",
      note: "Anteckning",
      reference: "Referens",
      markAsPaid: "Markera som betald",
      events: "Händelser",
      eventRedemption: "Presentkort inlöst",
      eventRefund: "Presentkortsåterbetalning",
      eventSettlement: "Betalning registrerad",
      eventRedemptionDetail: "{{to}} löste in ett presentkort utfärdat av {{from}}",
      eventRefundDetail: "{{from}} återbetalade ett presentkort utfärdat av {{to}}",
      eventSettlementDetail: "{{from}} betalade {{to}}",
      eventCreditNoteRedemption: "Tillgodokvitto inlöst",
      eventCreditNoteRefund: "Tillgodokvittoåterbetalning",
      eventCreditNoteRedemptionDetail:
        "{{to}} löste in ett tillgodokvitto utfärdat av {{from}}",
      eventCreditNoteRefundDetail:
        "{{from}} återbetalade ett tillgodokvitto utfärdat av {{to}}",
      invalidAmount: "Ange ett giltigt belopp",
      amountExceeds: "Beloppet överstiger utestående skuld",
      settleFailed: "Kunde inte registrera betalning",
      downloadReport: "Ladda ner rapport",
      downloadReportFailed: "Kunde inte ladda ner rapporten",
      report: "Rapport",
      reportFrom: "Från",
      reportTo: "Till",
      invalidReportDates: "Välj ett giltigt datumintervall",
    },
    creditNotesView: {
      title: "Tillgodokvitton",
      loading: "Laddar tillgodokvitton...",
      create: "Skapa tillgodokvitto",
      errorLoad: "Fel vid laddning av tillgodokvitton. Försök igen.",
      errorSave: "Fel vid sparande av tillgodokvitto. Försök igen.",
      successCreated: "Tillgodokvitto skapat",
      successUpdated: "Tillgodokvitto uppdaterat",
      successDeleted: "Tillgodokvitto borttaget",
      deleteConfirm: "Är du säker på att du vill ta bort detta tillgodokvitto?",
      empty: "Inga tillgodokvitton ännu.",
      emptyHint: "Skapa ett för att komma igång.",
      tableBarcode: "Streckkod",
      tableOriginalAmount: "Ursprungligt belopp",
      tableRemainingAmount: "Kvarvarande belopp",
      tableUseByDate: "Sista användningsdatum",
      tableCreated: "Skapad",
      tableActions: "Åtgärder",
      delete: "Ta bort",
      panelCreate: "Skapa tillgodokvitto",
      panelEdit: "Redigera tillgodokvitto",
    },
    listPages: {
      storesTitle: "Butiker",
      storesLoading: "Laddar butiker...",
      addStore: "Lägg till butik",
      emptyStores: "Inga butiker hittades.",
      createStorePanel: "Skapa ny butik",
      chainsTitle: "Kedjor",
      chainsLoading: "Laddar kedjor...",
      emptyChains: "Inga kedjor hittades.",
      resellersTitle: "Återförsäljare",
      resellersLoading: "Laddar återförsäljare...",
      addReseller: "Lägg till återförsäljare",
      emptyResellers: "Inga återförsäljare hittades.",
      createResellerPanel: "Skapa ny återförsäljare",
      searchStoresPlaceholder: "Sök butiker…",
      activeStoresOnly: "Endast aktiva",
      storesSearchNoResults: "Inga butiker matchar din sökning.",
    },
    apiKeysView: {
      title: "API-nyckelhantering",
      createdTitle: "API-nyckel skapad!",
      saveKeyHint: "Spara denna nyckel nu — den visas inte igen:",
      copyClipboard: "Kopiera till urklipp",
      createButton: "Skapa API-nyckel",
      name: "Namn",
      namePlaceholder: "t.ex. uppladdningsnyckel för paket",
      descriptionOptional: "Beskrivning (valfritt)",
      descriptionPlaceholder: "Beskriv vad nyckeln används till",
      permissions: "Behörigheter",
      create: "Skapa",
      errorLoad: "Fel vid laddning av API-nycklar. Försök igen.",
      loading: "Laddar API-nycklar...",
      empty: "Inga API-nycklar. Skapa en för att komma igång.",
      active: "Aktiv",
      inactive: "Inaktiv",
      permissionsLabel: "Behörigheter: {{list}}",
      createdLabel: "Skapad: {{date}}",
      lastUsedLabel: "Senast använd: {{date}}",
      deactivate: "Inaktivera",
      deactivateConfirm: "Är du säker på att du vill inaktivera denna API-nyckel?",
      delete: "Ta bort",
      deleteConfirm: "Är du säker på att du vill ta bort denna API-nyckel? Detta kan inte ångras.",
    },
    bundlesView: {
      title: "Pakethantering",
      columnVersions: "Versioner",
      emptyVersions: "Inga versioner hittades.",
      bundles: "Paket",
      bundlesAllBrandsSubtitle: "v{{version}} · Alla varumärken",
      bundlesBrandSubtitle: "v{{version}} · {{brand}}",
      emptyBundles: "Inga paket hittades för denna version.",
      emptyBrands: "Inga varumärken för denna version.",
      toggleBrands: "Visa varumärken",
      buildLabel: "Bygge",
      columnDescription: "Beskrivning",
      columnActions: "Åtgärder",
      pillAdmin: "Admin",
      pillPublic: "Publik",
      active: "Aktiv",
      inactive: "Inaktiv",
      adminBadge: "Admin: {{status}}",
      publicBadge: "Publik: {{status}}",
      platformSizes: "iOS: {{ios}} | Android: {{android}}",
      uploaded: "Uppladdad: {{date}}",
      gitHash: "Git: {{hash}}",
      description: "Beskrivning: {{text}}",
      activateAdmins: "Aktivera för administratörer",
      activateAll: "Aktivera för alla varumärken",
      activateBrandAdmins: "Aktivera admin för varumärke",
      activateBrandPublic: "Aktivera publikt för varumärke",
      activating: "Aktiverar...",
      activateAdminsConfirm:
        "Aktivera bygge {{build}} för administratörer på alla varumärken för v{{version}}?",
      activateAllConfirm:
        "Aktivera bygge {{build}} för alla varumärken på v{{version}}?",
      activateBrandAdminsConfirm:
        "Aktivera bygge {{build}} för administratörer på {{brand}}?",
      activateBrandPublicConfirm:
        "Aktivera bygge {{build}} publikt på {{brand}}?",
      activateBrandAllConfirm:
        "Aktivera bygge {{build}} för {{brand}}?",
      activateAdminsSuccess: "Aktiverad för administratörer på {{count}} varumärken.",
      activateAllSuccess: "Aktiverad för {{count}} varumärken.",
      activateBrandAdminsSuccess: "Aktiverad för administratörer på {{brand}}.",
      activateBrandPublicSuccess: "Aktiverad publikt på {{brand}}.",
      activateBrandAllSuccess: "Aktiverad på {{brand}}.",
      activateAdminsPartial:
        "Aktiverad för administratörer på {{activated}} varumärken. {{skipped}} varumärken hoppades över (bygget saknas).",
      activateAllPartial:
        "Aktiverad för {{activated}} varumärken. {{skipped}} varumärken hoppades över (bygget saknas).",
    },
    resellerOverview: {
      loading: "Laddar återförsäljare...",
      notFound: "Återförsäljaren hittades inte",
      pageTitle: "Återförsäljare översikt",
      editReseller: "Redigera återförsäljare",
      logoAlt: "Återförsäljarlogotyp",
      resellerName: "Återförsäljarnamn",
      id: "ID",
      brand: "Varumärke",
      contactEmail: "Kontakt e-post",
      contactEmailInfo: "Kontakt e-post info",
      contactPhone: "Kontakttelefon",
      contactPhoneInfo: "Kontakttelefon info",
      organizationNumber: "Organisationsnummer",
      address: "Adress",
      country: "Land",
      createdAt: "Skapad",
      editPanelTitle: "Redigera återförsäljare: {{name}}",
    },
    chainOverview: {
      loading: "Laddar kedja...",
      notFound: "Kedjan hittades inte",
      pageTitle: "Kedjeöversikt",
      chainName: "Kedjenamn",
      id: "ID",
      brand: "Varumärke",
      address: "Adress",
      country: "Land",
      organizationNumber: "Organisationsnummer",
      reseller: "Återförsäljare",
      noReseller: "Ingen återförsäljare",
      createdAt: "Skapad",
      updatedAt: "Uppdaterad",
    },
    storeCopy: {
      pageTitle: "Kopiera butik",
      storesTitle: "Butiker",
      description:
        "Kopiera inställningar och sortiment från en butik till en annan. Befintliga poster i målbutiken med samma ID skrivs över; övriga poster i målbutiken lämnas orörda. Försäljning, kvitton, lagersaldon, kunder, presentkort, betalsätt och integrationer kopieras aldrig.",
      sourceStore: "Kopiera från",
      targetStore: "Kopiera till",
      searchPlaceholder: "Sök butik på namn eller org.nummer",
      searchLoading: "Laddar butikssök...",
      searchHint: "Börja skriva för att söka butiker",
      searching: "Söker...",
      alreadySelected: "Redan vald",
      changeStore: "Byt",
      itemsTitle: "Vad ska kopieras",
      itemsDescription:
        "Butiksinställningar exkluderar namn, adress, kontaktuppgifter, valuta, språk, tidszon och integrationer.",
      selectAll: "Välj alla",
      selectNone: "Välj inga",
      groups: {
        settings: "Inställningar",
        catalog: "Sortiment",
        devices: "Enheter och bordskartor",
      },
      items: {
        STORE_SETTINGS: "Butiksinställningar",
        UNITS: "Enheter",
        COURSES: "Serveringar",
        SUPPLIERS: "Leverantörer",
        BOOKKEEPING_ACCOUNTS: "Bokföringskonton",
        PREP_STATIONS: "Bongplatser",
        PRODUCT_GROUPS: "Varugrupper",
        MODIFIER_GROUPS: "Tillvalsgrupper",
        MODIFIERS: "Tillval",
        PRODUCTS: "Produkter",
        OFFERS: "Erbjudanden",
        PRODUCT_PAGES: "Produktsidor",
        LAYOUTS: "Layouter",
        PRINTERS: "Skrivare",
        BARCODE_FORMATS: "Streckkodsformat",
        FLOOR_PLANS: "Bordskartor",
        DEVICE_CONFIGS: "Enhetskonfigurationer",
      },
      status: {
        PROCESSING: "Kopierar...",
      },
      start: "Starta kopiering",
      starting: "Startar...",
      latestJobTitle: "Senaste kopiering till denna butik",
      jobProgress: "({{copied}} av {{processed}} kopierade)",
      jobCompleted: "Kopieringen är klar. {{copied}} kopierade, {{failed}} misslyckades.",
      jobFailed: "Kopieringen misslyckades.",
      retry: "Försök igen",
      retrying: "Försöker igen...",
      confirmTitle: "Kopiera butik?",
      confirmMessage:
        "De valda posterna kopieras från {{source}} till {{target}}. Matchande poster i {{target}} skrivs över.",
      confirmStart: "Starta kopiering",
    },
    chainSettings: {
      pageTitle: "Inställningar",
      loading: "Laddar kedjeinställningar...",
      notFound: "Kedjan hittades inte",
      chainInfoTitle: "Kedjeuppgifter",
      chainInfoDescription: "Uppdatera kedjans namn, organisationsnummer och adress.",
      name: "Kedjenamn *",
      nameRequired: "Kedjenamn krävs",
      brand: "Varumärke *",
      brandRequired: "Varumärke krävs",
      orgNumber: "Organisationsnummer *",
      orgNumberRequired: "Organisationsnummer krävs",
      street: "Gata *",
      streetRequired: "Gata krävs",
      postalCode: "Postnummer *",
      postalCodeRequired: "Postnummer krävs",
      city: "Ort *",
      cityRequired: "Ort krävs",
      infoSaved: "Kedjeuppgifterna sparades",
      chainModeTitle: "Kedjeläge",
      chainModeDescription:
        "Kedjeläge låter dig hantera en gemensam katalog för alla butiker i kedjan. Butikerna kan då bara ändra de fält du tillåter.",
      chainModeLabel: "Aktivera kedjeläge",
      chainModeActive: "Kedjeläge är aktivt. Butikerna följer katalogpolicyn nedan.",
      sharedCustomersTitle: "Delade kunder",
      sharedCustomersDescription:
        "När detta är på ser alla butiker i kedjan samma kunder. När det är av ser varje butik bara kunder som skapats där.",
      sharedCustomersLabel: "Dela kunder mellan butiker",
      sharedCustomersSaved: "Kunddelning uppdaterad",
      sourceStore: "Kopiera katalog från butik",
      sourceStoreNone: "Kopiera inte någon butikskatalog",
      sourceStoreHint:
        "Valfritt. Den valda butikens katalog kopieras till kedjan och synkas sedan till de andra butikerna.",
      confirmTitle: "Aktivera kedjeläge?",
      confirmMessage:
        "Det går inte att stänga av senare. Kedjekatalogen skapas och butikerna följer kedjepolicyn.",
      confirmActivate: "Aktivera",
      jobProgress: "Kopierade {{copied}} av {{processed}} objekt.",
      jobFailed: "Aktiveringen av kedjeläge misslyckades. Du kan försöka igen där den stannade.",
      retry: "Försök igen",
      retrying: "Försöker igen...",
      phases: {
        COPY_UNITS: "Kopierar enheter…",
        COPY_COURSES: "Kopierar serveringar…",
        COPY_SUPPLIERS: "Kopierar leverantörer…",
        COPY_BOOKKEEPING_ACCOUNTS: "Kopierar bokföringskonton…",
        COPY_PREP_STATIONS: "Kopierar bongplatser…",
        COPY_PRODUCT_GROUPS: "Kopierar varugrupper…",
        COPY_MODIFIER_GROUPS: "Kopierar tillvalsgrupper…",
        COPY_MODIFIERS: "Kopierar tillval…",
        COPY_PRODUCTS: "Kopierar produkter…",
        COPY_OFFERS: "Kopierar erbjudanden…",
        COPY_PRODUCT_PAGES: "Kopierar produktsidor…",
        COPY_LAYOUTS: "Kopierar layouter…",
        ENABLE_CHAIN_MODE: "Aktiverar kedjeläge…",
        SYNC_UNITS: "Synkar enheter till butiker…",
        SYNC_COURSES: "Synkar serveringar till butiker…",
        SYNC_SUPPLIERS: "Synkar leverantörer till butiker…",
        SYNC_BOOKKEEPING_ACCOUNTS: "Synkar bokföringskonton till butiker…",
        SYNC_PREP_STATIONS: "Synkar bongplatser till butiker…",
        SYNC_PRODUCT_GROUPS: "Synkar varugrupper till butiker…",
        SYNC_MODIFIER_GROUPS: "Synkar tillvalsgrupper till butiker…",
        SYNC_MODIFIERS: "Synkar tillval till butiker…",
        SYNC_PRODUCTS: "Synkar produkter till butiker…",
        SYNC_OFFERS: "Synkar erbjudanden till butiker…",
        SYNC_PRODUCT_PAGES: "Synkar produktsidor till butiker…",
        SYNC_LAYOUTS: "Synkar layouter till butiker…",
        MOVE_GIFT_CARDS: "Flyttar presentkort till kedjan…",
        MOVE_CREDIT_NOTES: "Flyttar tillgodokvitton till kedjan…",
      },
      catalogPolicyTitle: "Kedjepolicy",
      catalogPolicyDescription:
        "Styr om butiker kan skapa egna katalogobjekt och vilka fält de får ändra lokalt.",
      catalogSettingsTitle: "Kataloginställningar",
      catalogSettingsDescription:
        "Dessa inställningar gäller för alla butiker i kedjan och kan inte ändras i butiksinställningarna.",
      defaultVAT: "Standardmoms",
      extraProductFieldsLabel: "Extra produktfält",
      extraProductFieldName: "Namn",
      extraProductFieldNamePlaceholder: "Fältnamn",
      extraProductFieldNameRequired: "Fältnamn krävs",
      extraProductFieldShowOnReceipt: "Visa på kvitto",
      addExtraProductField: "Lägg till fält",
      catalogSettingsSaved: "Kataloginställningarna sparades",
      storesCanCreateLocal: "Butiker kan skapa lokala objekt",
      storesCanCreateLocalHint:
        "När det är avstängt kan butiker inte skapa egna objekt i den här delen av katalogen.",
      overridableFields: "Fält som kan ändras lokalt",
      overridableFieldsHint:
        "Butiker får ändra dessa fält lokalt på katalogobjekt som tillhör kedjan.",
      policySaved: "Kedjepolicyn sparades",
      domains: {
        products: "Produkter",
        productGroups: "Varugrupper",
        modifiers: "Tillval",
        modifierGroups: "Tillvalsgrupper",
        courses: "Serveringar",
        units: "Enheter",
        suppliers: "Leverantörer",
        extraProductFields: "Extra produktfält",
        bookkeepingAccounts: "Bokföringskonton",
        prepStations: "Bongplatser",
        offers: "Erbjudanden",
        productPages: "Produktsidor",
        layouts: "Layouter",
      },
      fields: {
        unitPrice: "Styckpris",
        takeawayPrice: "Takeaway-pris",
        prepStationId: "Bongplats",
        bookkeepingAccountId: "Bokföringskonto",
        name: "Namn",
        accountNumber: "Kontonummer",
        printerIds: "Skrivare",
        printerOverrides: "Skrivarundantag",
        isMaster: "Spegla bongplatser",
        mirroredPrepStationIds: "Bongplatser att spegla",
        enabled: "Aktiverad",
        priority: "Prioritet",
      },
    },
    resellerAvailableBillingItemsView: {
      title: "Paket/tillägg",
      loading: "Laddar paket/tillägg...",
      addButton: "Lägg till paket/tillägg",
      bulkEnableButton: "Aktivera flera",
      bulkEnableTitle: "Aktivera faktureringsposter för återförsäljare",
      errorLoad: "Fel vid laddning av paket/tillägg. Försök igen.",
      errorUpdate: "Fel vid uppdatering av paket/tillägg. Försök igen.",
      successAdded: "Paket/tillägg tillagd",
      successUpdated: "Paket/tillägg uppdaterad",
      successRemoved: "Paket/tillägg borttagen",
      deleteConfirm: "Är du säker på att du vill ta bort denna paket/tillägg?",
      empty: "Inga paket/tillägg ännu. Lägg till en för att komma igång.",
      tableName: "Namn",
      tableType: "Typ",
      tableDescription: "Beskrivning",
      tablePricing: "Priser",
      tableActions: "Åtgärder",
      remove: "Ta bort",
      panelAdd: "Lägg till paket/tillägg",
      panelEdit: "Redigera paket/tillägg",
    },
    notFound: {
      subtitle: "Sidan hittades inte",
      message: "Sidan du söker finns inte eller har flyttats.",
      goHome: "Till startsidan",
    },
    integrationForm: {
      typeLabel: "Integrationstyp *",
      selectPlaceholder: "Välj integrationstyp",
    },
    packageSelectionModal: {
      saveFailed: "Kunde inte spara: {{message}}",
      saving: "Sparar...",
      saveSelection: "Lägg till",
    },
    priceList: {
      title: "Prislista",
      intro:
        "Översikt över tillgängliga paket, tillägg, priser och vilka funktioner som ingår.",
      loading: "Laddar prislista...",
      error: "Kunde inte ladda prislistan. Försök igen.",
      empty: "Inga paket eller tillägg är tillgängliga ännu.",
      packagesSection: "Paket och priser",
      addonsSection: "Tillägg",
      featureDescription: {
        FISCALIZATION:
          "Juridiskt kassaregister med kontrollenhet, journalminne, växelkassa och rapporter som Z-dagrapport och periodrapport.",
        DISCOUNT:
          "Ge rabatt på enskilda rader eller hela köpet via kassan och som layoutknapp.",
        GROUPS:
          "Strukturera sortimentet i varugrupper och få statistik per grupp.",
        PRODUCT_VARIANTS:
          "Hantera produkter med varianter, till exempel storlek eller färg, under samma produkt.",
        RESTAURANT_VARIANTS:
          "Hantera restaurangvarianter där basprodukten är separata från tillval eller storlekar.",
        LAYOUTS:
          "Anpassa knappar och navigering i kassan med egna layouter.",
        FLOOR_PLANS:
          "Bordskarta för att välja bord vid servering i restaurang.",
        CREDIT_NOTE:
          "Utfärda och använda tillgodokvitton som betalmetod.",
        GIFT_CARD:
          "Sälj presentkort och ta betalning med presentkort.",
        AUTOMATIC_BOOKKEEPING:
          "Automatiska bokföringsverifikat och koppling till bokföringssystem.",
        RECEIPT_LOGO: "Egen logotyp på kvitton.",
        EXTRA_PRODUCT_FIELDS:
          "Egna fält på produkter utöver standardfälten.",
        CUSTOMER_DISPLAY:
          "Kundskärm som visar köp, totalsumma och QR-kod.",
        BARCODE_SCANNING:
          "Streckkodsskanning med EAN i kassan och som layoutknapp.",
        SIMPLE_STOCK: "Följ lagerantal per produkt.",
        PHONE_SUPPORT: "Telefonsupport från Kassaro.",
        BUNDLE_MANAGEMENT:
          "Versionshantering av produktdata mellan enheter.",
        LABEL_PRINTING: "Skriv ut etiketter för produkter.",
        ORDER: "Skapa och hantera order som betalmetod.",
        INVOICE: "Skapa och hantera fakturor.",
        SERIAL_SCALE:
          "Anslut seriell våg för att väga varor vid försäljning.",
        PURCHASE_NOTE: "Registrera inköpsnotor.",
        PRODUCT_INFO_BOX:
          "Visa produktinformation i kassan.",
        MODIFIERS:
          "Tillval och modifikatorer på rätter och produkter.",
        TIPS: "Hantera dricks i kassan vid betalning.",
        PREP_TICKETS:
          "Skriv ut bongar till kök när beställningar frammar.",
        COMBINED_PREP_TICKETS:
          "Kombinera flera notor på en bong vid utskrift.",
        SAVE_TABS:
          "Parkera påbörjade notor och öppna dem igen senare.",
        SPLIT_TABS:
          "Dela en nota mellan flera betalningar eller gäster.",
        BILL_PREVIEW:
          "Visa förnota innan slutlig betalning.",
        TAKEOUT_PRICE:
          "Separata avhämtningspriser på produkter.",
        ONLINE_ORDER:
          "Ta emot och hantera onlinebeställningar.",
        PURCHASE_PRICE:
          "Registrera och följa inköpspris på produkter.",
        STAFF:
          "Personalhantering med behörighetsgrupper och inloggning per användare.",
        INTAKE: "Registrera och följa inleverans av varor.",
        PRODUCT_SYNC:
          "Synkronisera produkter med externa system som Shopify.",
        PRODUCT_IMAGES: "Ladda upp och visa bilder på produkter.",
        STOCK_TAKE: "Räkna fysiskt lager och tillämpa differenser.",
        STOCK_LOCATIONS: "Lagersaldo per lagerplats och redigering av lager per lagerplats på produkter.",
        STOCK_POLICIES: "Lagerregler med min- och maxnivåer, säsonger och lagerbevakning.",
        INVENTORY_COSTING: "Varukostnad enligt FIFO från inköpspriset vid inleverans, och spårning av serienummer.",
        SUPPLIERS: "Hantera leverantörer och koppla dem till produkter.",
        CUSTOMERS:
          "Spara kunder, koppla dem till ett köp och exportera eller radera deras personuppgifter.",
        SERVICE_ORDERS:
          "Skapa serviceordrar från varukorgen, följ status och sälj dem senare.",
        EXTERNAL_INTEGRATIONS:
          "Skicka försäljning till externa system som Personalkollen.",
        PUBLIC_API:
          "Låt egna system och partner läsa och ändra produkter via API och ta emot webhooks.",
      },
    },
    userForm: {
      errorAdd: "Kunde inte lägga till användare. Försök igen.",
      createNewUser: "Skapa ny användare",
      toggleNewUser: "Ny användare (kräver lösenord)",
      toggleExistingUser: "Befintlig användare (endast e-post)",
      emailRequired: "E-post krävs",
      emailInvalid: "Ogiltigt e-postformat",
      emailLabel: "E-post *",
      emailPlaceholder: "Ange e-postadress",
      passwordRequiredNew: "Lösenord krävs för nya användare",
      passwordMinLength: "Lösenordet måste vara minst 6 tecken",
      passwordLabel: "Lösenord *",
      passwordPlaceholder: "Ange lösenord",
      accessLabel: "Åtkomst",
      accessChain: "Kedja (alla butiker i kedjan)",
      accessStore: "Endast denna butik",
      permissionGroupLabel: "Behörighetsgrupp",
      permissionGroupDefault: "Standard behörighetsgrupp",
      adding: "Lägger till...",
      addUser: "Lägg till användare",
    },
    deviceForm: {
      platform: "Plattform",
      osVersion: "OS-version",
      appVersion: "Appversion",
      name: "Namn",
      namePlaceholder: "Namnlös enhet",
      serialNumber: "Serienummer",
      serialNumberPlaceholder: "t.ex. ABC123456789",
      active: "Aktiv",
      activeState: "Aktiv",
      inactiveState: "Inaktiv",
      deviceConfig: "Konfiguration",
      none: "Ingen",
      lastSeen: "Senast använd",
      created: "Skapad",
    },
    printerForm: {
      editTitle: "Redigera skrivare",
      createTitle: "Skapa skrivare",
      name: "Namn",
      ipAddress: "IP-adress",
      ipRequired: "Ange en IP-adress",
      create: "Skapa",
      update: "Uppdatera",
    },
    printerList: {
      type: "Typ",
      ip: "IP",
    },
    adminForms: {
      warningNotBookkept:
        "Varning: Ändringar som görs av administratörer bokförs inte.",
    },
    giftcardForm: {
      cardNumber: "Kortnummer",
      initialAmount: "Startbelopp",
      remainingAmount: "Kvarvarande belopp",
      validUntil: "Giltigt till",
      createdAt: "Skapad",
    },
    creditNoteForm: {
      originalAmount: "Ursprungligt belopp",
      remainingAmount: "Kvarvarande belopp",
      useByDate: "Använd senast",
      barcode: "Streckkod",
      createdAt: "Skapad",
    },
    resellerForm: {
      errorUpdating: "Kunde inte uppdatera återförsäljare. Försök igen.",
      errorCreating: "Kunde inte skapa återförsäljare. Försök igen.",
      nameRequired: "Återförsäljarnamn krävs",
      resellerName: "Återförsäljarnamn *",
      resellerNamePlaceholder: "Ange återförsäljarnamn",
      contactEmail: "Kontakt e-post *",
      contactEmailPlaceholder: "Ange kontakt e-post",
      contactEmailRequired: "Kontakt e-post krävs",
      emailInvalid: "Ogiltigt e-postformat",
      contactEmailInfo: "Info om kontakt e-post",
      contactEmailInfoPlaceholder: "Ange info om kontakt e-post",
      contactPhone: "Kontakttelefon",
      contactPhonePlaceholder: "Ange kontakttelefon",
      contactPhoneInfo: "Info om kontakttelefon",
      contactPhoneInfoPlaceholder: "Ange info om kontakttelefon",
      extraInfo: "Extra info",
      extraInfoPlaceholder: "Ange extra info",
      street: "Gatuadress *",
      streetRequired: "Gatuadress krävs",
      streetPlaceholder: "Ange gatuadress",
      postalCode: "Postnummer *",
      postalCodeRequired: "Postnummer krävs",
      postalCodePlaceholder: "Ange postnummer",
      city: "Ort *",
      cityRequired: "Ort krävs",
      cityPlaceholder: "Ange ort",
      orgNumber: "Organisationsnummer *",
      orgNumberRequired: "Organisationsnummer krävs",
      orgNumberPlaceholder: "Ange organisationsnummer",
      country: "Land *",
      brand: "Varumärke",
      brandPlaceholder: "Ange varumärke (standard: Kassaro)",
      logo: "Logotyp",
      selectedFile: "Vald: {{name}} ({{size}} KB)",
      logoPreviewAlt: "Förhandsvisning av logotyp",
      updating: "Uppdaterar...",
      creating: "Skapar...",
      updateReseller: "Uppdatera återförsäljare",
      createReseller: "Skapa återförsäljare",
    },
    resellerAvailableBillingItemForm: {
      selectTitle: "Välj tillgänglig faktureringspost",
      emptySelect: "Inga tillgängliga faktureringsposter att lägga till.",
      pricingMonthly: "Månadsvis: {{formatted}}",
      pricingOneTime: "Engångs: {{formatted}}",
      pricing36mo: "36 mån: {{formatted}}",
      defaultPricing: "Standardpris: {{pricing}}",
      editPricingTitle: "Redigera pris för {{name}}",
      monthlyOptional: "Månadspris (valfritt)",
      oneTimeOptional: "Engångspris (valfritt)",
      prepaid36Optional: "Förskottspris 36 månader (valfritt)",
      add: "Lägg till",
    },
    integrationDetails: {
      nameRequired: "Namn krävs",
      nameLabel: "Namn *",
      nameOptional: "Namn",
      namePlaceholder: "Ange integrationsnamn",
      percentageRequired: "Procent krävs",
      percentageLabel: "Procent *",
      apiKeyRequired: "API-nyckel krävs",
      apiKeyLabel: "API-nyckel *",
      apiKeyPlaceholder: "Ange API-nyckel",
      merchantIdRequired: "Handlar-ID krävs",
      merchantIdLabel: "Handlar-ID *",
      merchantIdPlaceholder: "Ange handlar-ID",
      accountIdRequired: "Konto-ID krävs",
      accountIdLabel: "Konto-ID *",
      accountIdPlaceholder: "Ange konto-ID",
      usernameRequired: "Användarnamn krävs",
      usernameLabel: "Användarnamn *",
      usernamePlaceholder: "Ange användarnamn",
      passwordRequired: "Lösenord krävs",
      passwordLabel: "Lösenord",
      passwordLabelNew: "Lösenord *",
      passwordPlaceholder: "Ange lösenord",
      westpayDefaultName: "Westpay + {{storeName}}",
      softpayDefaultName: "SoftPay + {{storeName}}",
      netsDefaultName: "Nets + {{storeName}}",
      personalkollenDefaultName: "Personalkollen + {{storeName}}",
      personalkollenApiKeyLabel: "Nyckel till kassakoppling",
      personalkollenApiKeyLabelNew: "Nyckel till kassakoppling *",
      personalkollenApiKeyHelp:
        "Finns i Personalkollen under Inställningar → Arbetsplatser, kolumnen ”Nyckel till kassakoppling”. Nyckeln kontrolleras mot Personalkollen när du sparar. Lämna tomt för att behålla nuvarande nyckel.",
      personalkollenExportError: {
        UNAUTHORIZED:
          "Personalkollen godkände inte nyckeln vid senaste försäljningen ({{date}}). Ange en ny nyckel och spara.",
        INVALID_DATA: "Personalkollen avvisade en försäljning ({{date}}). Kontakta support.",
      },
      marketpayDefaultName: "MarketPay + {{storeName}}",
      storeCodeOptional: "Butikskod",
      storeCodePlaceholder: "Ange butikskod",
      marketpayMerchantId: "Tap to Pay handlar-ID",
      marketpayMerchantIdPlaceholder: "Ange handlar-ID från onboarding",
      marketpayClientId: "Market Pay klient-ID",
      marketpayClientIdPlaceholder: "Ange klient-ID för SSO",
      merchantEmailLabel: "Handlarens e-post *",
      merchantEmailPlaceholder: "handlare@example.com",
      merchantEmailRequired: "Handlarens e-post krävs",
      merchantEmailInvalid: "Ange en giltig e-postadress",
      privateCardsLabel: "Privata kontokort (%) *",
      isvPercentagePlaceholder: "0.69",
      isvPercentageRequired: "ISV-procent krävs",
      isvPercentageBelowBase:
        "Avgiften kan inte vara lägre än Vivas basavgift på {{base}}",
      isvPercentageTier1: "{{rate}} — från 300 000 kr per månad",
      isvPercentageTier2: "{{rate}} — från 100 000 kr per månad",
      isvPercentageTier3: "{{rate}} — från 50 000 kr per månad",
      isvPercentageTier4: "{{rate}} — under 50 000 kr per månad",
      isvPercentageCustom: "Anpassad avgift…",
      isvPercentageCustomLabel: "Anpassad avgift för privata kontokort (%)",
      isvAmountLabel:
        "Fast påslag per transaktion (öre) – valfritt, går oavkortat till marginalen",
      isvAmountOrePlaceholder: "0",
      isvAmountRequired: "ISV-belopp krävs",
      isvCurrencyLabel: "Valuta *",
      feeSplitCardRatesHeading: "Handlarens avgift per korttyp",
      feeSplitPrivateCards: "Privata kontokort",
      feeSplitCreditCards: "Kreditkort (+{{surcharge}})",
      feeSplitCompanyCards: "Företagskort (+{{surcharge}})",
      feeSplitHeading: "Avgift och intäktsdelning",
      feeSplitVivaBase: "Vivas del",
      feeSplitIsvFee: "Vår marginal (ISV-avgift)",
      feeSplitResellerShare: "Din andel (50 % av ISV-avgiften)",
      feeSplitKassaroShare: "Kassaros andel (50 % av ISV-avgiften)",
      feeSplitExampleHeading:
        "Exempel på ett köp av {{amount}} med privat kontokort",
      feeSplitExampleTotal: "Handlaren betalar",
      feeSplitExampleFee: "ISV-avgift",
      feeSplitExampleShare: "Din andel",
      vivaAdminOnlyIdsHint: "Endast administratörer kan ändra handlar- och konto-ID.",
      vivaCreatedNextSteps:
        "Integrationen skapades. Slutför handlar-onboarding via länken nedan när den finns.",
      acquirerRequestInfo:
        "En förfrågan skickas till Kassaro med butikens företagsuppgifter. Vi kontaktar dig för att slutföra inlösenavtalet.",
      acquirerRequestSubmit: "Skicka förfrågan",
      acquirerRequestSent:
        "Förfrågan har skickats till Kassaro. Vi återkommer inom kort.",
      acquirerRequestDone: "Klar",
      acquirerCommentLabel: "Kommentar",
      acquirerCommentPlaceholder: "Något mer Kassaro bör veta om förfrågan",
      acquirerFeeLevelLabel: "Prislista *",
      acquirerFeeLevelRequired: "Välj en prislista",
      acquirerFeeLevelOption: "Prislista {{level}} — {{rate}} ({{model}})",
      acquirerFeeModel: {
        REV_SHARE: "rev share",
        BUY_RATE: "buy rate",
      },
      acquirerFeeRatesHeading: "Priser för prislista {{level}}",
      acquirerFeePrivateDebit: "Privat kontokort",
      acquirerFeePrivateCredit: "Privat kreditkort",
      acquirerFeeBusiness: "Företagskort",
      acquirerFeeModelNote: {
        REV_SHARE:
          "Prislista 1 och 2 är rev share vilket kräver högre omsättning hos kunden.",
        BUY_RATE:
          "Prislista 3–6 är buy rate. Förtjänsten är dubbelt så stor på prislista 4 mot prislista 3.",
      },
      acquirerFeeShareNote: "Vi delar 50/50 på inkomsterna på inlösen.",
      onboardingStatusLabel: "Onboardingstatus",
      onboardingUrlLabel: "Onboarding-URL",
      vivaOnboardingLinkHeading: "Länk för handlar-onboarding",
      vivaOpenOnboardingLink: "Öppna onboarding-länk",
      vivaCopyOnboardingLink: "Kopiera onboarding-länk",
      vivaOnboardingStatusStarted: "Påbörjad",
      vivaOnboardingStatusCompleted: "Slutförd",
      vivaOnboardingStatusUnknown: "Okänd",
      vivaOnboardingDone: "Klar",
      vivaChainRequired:
        "Denna butik saknar koppling till en kedja. En kedja krävs för att skapa en Viva-integration.",
    },
    fortnoxIntegration: {
      type: "Typ",
      name: "Fortnox",
      managedOAuth:
        "Denna integration hanteras via OAuth. För att återansluta, använd OAuth-flödet.",
      oauthSetup: "OAuth-konfiguration",
      connectInfo:
        "Klicka på knappen nedan för att ansluta ditt Fortnox-konto. Du omdirigeras till Fortnox för att godkänna integrationen.",
      connectButton: "Anslut Fortnox",
    },
    spirisIntegration: {
      type: "Typ",
      name: "Spiris",
      managedOAuth:
        "Denna integration hanteras via OAuth. För att återansluta, använd OAuth-flödet.",
      oauthSetup: "OAuth-konfiguration",
      connectInfo:
        "Klicka på knappen nedan för att ansluta ditt Spiris-konto. Du omdirigeras till Spiris för att godkänna integrationen.",
      connectButton: "Anslut Spiris",
    },
    packageSelection: {
      paymentTerms: "Betalningsvillkor",
      billingMonthly: "Månadsvis",
      billingQuarterly: "Kvartalsvis",
      billingYearly: "Årsvis",
      billingTwoYears: "2 år",
      billingThreeYears: "3 år",
      billingFourYears: "4 år",
      billingFiveYears: "5 år",
      startDate: "Startdatum",
      startDateHint: "När ändringarna aktiveras och fakturering påbörjas",
      subscriptionPackages: "Prenumerationspaket",
      loadingPackages: "Laddar paket...",
      addons: "Tillägg",
      loadingAddons: "Laddar tillägg...",
      extraDevices: "Extra enheter",
      activeDevices: "Enheter",
      activePackage: "Aktivt paket",
      selectPackage: "Välj paket",
      changePackage: "Byt paket",
      changeAddons: "Ändra tillägg",
      addAddons: "Lägg till tillägg",
      changePaymentTerminals: "Ändra terminaler",
      addTerminals: "Lägg till betalterminaler",
      totalTerminals_one: "{{count}} terminal",
      totalTerminals_other: "{{count}} terminaler",
      terminalsActiveUnused: "Aktiva {{active}} · Oanvända {{unused}}",
      terminalsActiveOverage: "Aktiva {{active}} · {{overage}} över licens",
      scheduledTerminalChange: "Från {{date}}: {{count}} terminaler",
      terminalQuantityHistory: "Schemalagda antal",
      scheduledDeviceChange: "Från {{date}}: {{count}} enheter",
      changeDevices: "Ändra enheter",
      editDetails: "Redigera detaljer",
      billingTerms: "Faktureringsvillkor",
      acquirers: "Inlösenavtal",
      addAcquirer: "Lägg till inlösenavtal",
      editAcquirer: "Redigera inlösenavtal: {{name}}",
      noAcquirers: "Inga inlösenavtal ännu.",
      monthlyCostSummary: "Månadskostnad",
      monthlyCostTotal: "Totalt",
      noMonthlyCost: "Ingen återkommande månadskostnad.",
      noActivePackage: "Inget aktivt paket.",
      noActiveAddons: "Inga aktiva tillägg.",
      loading: "Laddar...",
      deviceCount: "Antal enheter",
      terminalCount: "Antal terminaler",
      firstDeviceIncluded: "Första enheten ingår",
      totalDevices_one: "{{count}} enhet",
      totalDevices_other: "{{count}} enheter",
      includedInPackage_one: "{{count}} ingår i paketet",
      includedInPackage_other: "{{count}} ingår i paketet",
      includedPrice: "Ingår",
      extraDevicesBillable_one: "{{count}} extra enhet",
      extraDevicesBillable_other: "{{count}} extra enheter",
      extraDevicesCost: "{{price}}/mån styck · {{total}}/mån",
      noExtraDevicesCost: "Ingen extrakostnad",
      deviceChangeInfo:
        "Paketet inkluderar alltid {{count}} enhet. Extra enheter faktureras månadsvis från det datum du väljer.",
      deviceChangePreview: "Kostnadsöversikt",
      deviceQuantityHistory: "Schemalagda antal",
      scheduledDeviceChanges_one: "{{count}} schemalagd ändring",
      scheduledDeviceChanges_other: "{{count}} schemalagda ändringar",
      additionalDevices_one: "Ytterligare {{count}} enhet:",
      additionalDevices_other: "Ytterligare {{count}} enheter:",
      perMonthPerDevice: "/mån per enhet",
      total: "Totalt",
      perMonth: "/mån",
      discountOff: "−{{amount}}",
      paymentTerminals: "Betalterminaler",
      manageTerminals: "Hantera terminaler",
      selectTerminalsModal: "Välj betalterminaler",
      done: "Klar",
      price: "Pris",
      add: "Lägg till",
      perPeriod: "Per period",
      perMonthUnit: "Per månad/enhet",
      paidImmediately: "Betala direkt",
      changesOnSave: "Ändringar vid sparande",
      endsOn: "Avslutas {{date}}",
      startsOn: "Startar {{date}}",
      metaSubscription: "Prenumerationspaket",
      metaAddon: "Tillägg",
      metaExtraDevices: "Extra enheter",
      extraDevicesFallback: "Extra enheter",
      quantityPcs: "{{count}} st",
      quantity: "Antal",
      extraDeviceQuantity: "Extra enheter",
      effectiveFrom: "Gäller från",
      saveQuantity: "Spara antal",
      savingQuantity: "Sparar...",
      noExtraDevices: "Inga extra enheter licensierade.",
      quantityFrom: "{{quantity}} från {{from}}",
      quantityFromUntil: "{{quantity}} från {{from}} till {{until}}",
      noPaymentTerminals: "Inga betalterminaler ingår.",
      providerColumn: "Leverantör",
      billingModelColumn: "Debitering",
      includedColumn: "Ingår",
      usedColumn: "Använt",
      billingModelLicensed: "Licens per terminal",
      billingModelMetered: "Förbrukning ({{yearMonth}})",
      meteredUsageOverage: "{{devices}} ({{overage}} över)",
      meteredOverageWarning:
        "Fler Softpay-enheter har använts än vad abonnemanget inkluderar. Överskottet faktureras för hela månaden.",
    },
    oneTimeSecret: {
      copy: "Kopiera",
      copied: "Kopierad",
      done: "Klar",
    },
    storeSettings: {
      title: "Inställningar",
      general: "Allmänt",
      storeInfo: "Butiksuppgifter",
      stock: "Lager",
      loading: "Laddar inställningar...",
      api: "API",
      webhooksNav: "Webhooks",
      apiClients: {
        title: "API-nycklar",
        description:
          "Låt egna system och partner läsa och ändra butikens produkter via Kassaros API. Varje nyckel hör till den här butiken och har en egen API-användare, så ändringar syns i journalen som till exempel ”Webbshop (API)”.",
        name: "Namn",
        namePlaceholder: "Till exempel Webbshop",
        access: "Åtkomst",
        scope: {
          "products:read": "Produkter: läsa",
          "products:write": "Produkter: skriva",
        },
        scopeHint: {
          "products:read": "Lista och läsa produkter",
          "products:write": "Skapa, ändra och ta bort produkter",
        },
        create: "Skapa nyckel",
        showOnce:
          "Kopiera nyckeln nu. Den visas bara den här gången och kan inte hämtas igen.",
        active: "Aktiv",
        revoked: "Återkallad",
        keyEnding: "Slutar på {{last4}}",
        created: "Skapad {{date}}",
        lastUsed: "Senast använd {{date}}",
        neverUsed: "Aldrig använd",
        revoke: "Återkalla",
        empty: "Det finns inga API-nycklar ännu.",
        deleteTitle: "Ta bort API-nyckel",
        deleteMessage:
          "Vill du ta bort {{name}}? System som använder nyckeln slutar fungera direkt.",
        revokeTitle: "Återkalla API-nyckel",
        revokeMessage:
          "Vill du återkalla {{name}}? System som använder nyckeln slutar fungera direkt, och nyckeln kan inte aktiveras igen.",
      },
      webhooks: {
        title: "Webhooks",
        description:
          "Kassaro skickar en signerad HTTPS-förfrågan till din adress när något du väljer händer i butiken.",
        url: "Adress (HTTPS)",
        endpointDescription: "Beskrivning",
        eventsLabel: "Händelser",
        events: {
          "product.created": "Produkt skapad",
          "product.updated": "Produkt ändrad",
          "product.deleted": "Produkt borttagen",
          "sale.completed": "Köp genomfört",
        },
        add: "Lägg till webhook",
        secretShowOnce:
          "Kopiera signeringsnyckeln nu. Den visas bara den här gången. Mottagaren använder den för att kontrollera att förfrågningarna kommer från Kassaro.",
        status: {
          ACTIVE: "Aktiv",
          PAUSED: "Pausad",
          DISABLED: "Avstängd",
        },
        failingSince:
          "Leveranserna har misslyckats sedan {{date}}. Webhooken stängs av efter tre dygn utan en lyckad leverans.",
        sendTest: "Skicka test",
        testSucceeded: "Testet lyckades (HTTP {{status}}).",
        testFailed: "Testet misslyckades: {{error}}",
        pause: "Pausa",
        activate: "Aktivera",
        rotateSecret: "Byt signeringsnyckel",
        deliveries: "Senaste leveranser ({{count}})",
        deliveryTime: "Tid",
        deliveryEvent: "Händelse",
        deliveryAttempt: "Försök",
        deliveryResult: "Resultat",
        deliveryDuration: "Tid att svara",
        empty: "Det finns inga webhooks ännu.",
        deleteTitle: "Ta bort webhook",
        deleteMessage: "Vill du sluta skicka händelser till {{url}}?",
      },
      valuation: {
        title: "Lagervärdering",
        description:
          "Hur lagervärdet och varukostnaden för sålda varor räknas i statistik, lagerrapport och bokföring.",
        method: "Värderingsmetod",
        purchasePrice: "Inköpspris",
        purchasePriceDescription:
          "Lagret värderas till produktens nuvarande inköpspris. Enkelt, men värdet ändras när du ändrar priset.",
        fifo: "FIFO",
        fifoDescription:
          "Inköpspriset sparas vid varje inleverans och sålda varor får sin kostnad från de äldsta inleveranserna först. Krävs för serienummer.",
        active: "Aktiv",
        valuePer: "Värdera per",
        pool: {
          LOCATION: "Lagerplats",
          STORE: "Butik",
        },
        poolInline: {
          LOCATION: "lagerplats",
          STORE: "butik",
        },
        poolHint: {
          LOCATION:
            "Varje lagerplats har egna inleveranser. Vid lagerflytt följer kostnaden med varorna.",
          STORE:
            "Butikens lagerplatser värderas tillsammans. Flyttar inom butiken påverkar inte värdet.",
        },
        activateWarning:
          "Startlagret värderas till produkternas inköpspris när du aktiverar. Aktivera utanför öppettid: försäljning medan startlagret läses in kan räknas två gånger. Valet går inte att ändra efteråt.",
        cancel: "Avbryt",
        activate: "Aktivera FIFO",
        activating: "Aktiverar...",
        activeSince: "FIFO per {{pool}}, aktiv sedan {{date}}",
        showStockValue: "Visa lagervärde",
      },
    },
    stock: {
      title: "Lager",
      loading: "Laddar lagervärde...",
      errorLoad: "Kunde inte ladda lagervärdet.",
      notActiveTitle: "FIFO-värdering är inte aktiverad",
      notActiveDescription:
        "Lagervärde och varukostnad enligt FIFO visas här när du har aktiverat FIFO under Inställningar.",
      openSettings: "Gå till inställningar",
      valueTitle: "Lagervärde",
      activeSince: "FIFO per {{pool}}, aktiv sedan {{date}}",
      totalValue: "Lagervärde",
      inStock: "I lager",
      units_one: "{{count}} st",
      units_other: "{{count}} st",
      provisional: "Preliminär kostnad",
      products_one: "{{count}} produkt",
      products_other: "{{count}} produkter",
      search: "Sök produkt",
      searchPlaceholder: "Namn eller variant",
      location: "Lagerplats",
      allLocations: "Alla lagerplatser",
      product: "Produkt",
      quantity: "Antal",
      averageCost: "Snittkostnad",
      value: "Värde",
      empty: "Inget lager med inköpspris än.",
      provisionalNote:
        "* Mer har sålts än det finns i lager. Varukostnaden är preliminär tills nästa inleverans.",
      serialIssues: "Serienummer att kontrollera",
      serialIssuesDescription:
        "Försäljning där serienumret inte fanns i lager, eller där en vara med serienummer såldes utan serienummer. Kostnaden är preliminär.",
      date: "Datum",
      serial: "Serienummer",
      issue: "Avvikelse",
      issueReason: {
        UNKNOWN_SERIAL: "Serienumret fanns inte i lager",
        MISSING_SERIAL: "Såld utan serienummer",
      },
      layers: {
        show: "Visa inleveranser",
        showFor: "Visa inleveranser för {{name}}",
        loading: "Laddar inleveranser...",
        errorLoad: "Kunde inte ladda inleveranserna.",
        receivedAt: "Inlevererad",
        from: "Från",
        remaining: "Kvar",
        remainingOf: "{{remaining}} av {{received}}",
        withoutSerial_one: "{{count}} st utan serienummer",
        withoutSerial_other: "{{count}} st utan serienummer",
        unitCost: "Inköpspris",
        transferFrom: "Lagerflytt från {{location}}",
        source: {
          OPENING: "Startlager",
          INTAKE: "Inleverans",
          TRANSFER_IN: "Lagerflytt",
          RETURN: "Retur",
          SALE: "Retur",
          ADJUSTMENT: "Justering",
          TRANSFER_OUT: "Lagerflytt",
        },
        empty: "Inget i lager.",
        deficit_one:
          "{{count}} st har sålts utan lager och har preliminär kostnad {{cost}}. Nästa inleverans räknas av mot den först.",
        deficit_other:
          "{{count}} st har sålts utan lager och har preliminär kostnad {{cost}} per styck. Nästa inleverans räknas av mot dem först.",
        next: "Äldsta inleveransen säljs först. Nästa sålda vara kostar {{cost}}.",
        semiLive: "Uppdateras inom någon minut efter försäljning och inleverans.",
      },
    },
    entitlements: {
      sectionTitle: "Aktiva funktioner",
      loading: "Laddar funktioner...",
      deviceLimit: "{{devices}} licensierade enheter",
      noFeatures: "Inga funktioner beviljade.",
      sourceName: "Beviljas av",
      sourceQuantity: "Antal",
      sourceGrants: "Inkluderar",
      sourcePeriod: "Period",
      grantsDevices: "{{devices}} extra enheter",
      ongoing: "vidare",
    },
    productImportDefaultValues: {
      defaultVat: "Standardmoms",
    },
    storeForm: {
      nameRequired: "Juridiskt namn krävs",
      storeName: "Juridiskt namn *",
      storeNamePlaceholder: "Ange juridiskt namn",
      organizationNumber: "Organisationsnummer *",
      organizationNumberPlaceholder: "Ange organisationsnummer",
      organizationNumberRequired: "Organisationsnummer krävs",
      displayName: "Visningsnamn *",
      displayNamePlaceholder: "Ange visningsnamn",
      displayNameRequired: "Visningsnamn krävs",
      street: "Gatuadress *",
      streetPlaceholder: "Ange gatuadress",
      streetRequired: "Gatuadress krävs",
      postalCode: "Postnummer *",
      postalCodePlaceholder: "Ange postnummer",
      postalCodeRequired: "Postnummer krävs",
      city: "Ort *",
      cityPlaceholder: "Ange ort",
      cityRequired: "Ort krävs",
      contactPerson: "Kontaktperson *",
      contactPersonPlaceholder: "Ange kontaktperson",
      contactPersonRequired: "Kontaktperson krävs",
      contactEmail: "Kontakt e-post *",
      contactEmailPlaceholder: "Ange kontakt e-post",
      contactEmailRequired: "Kontakt e-post krävs",
      contactPhone: "Kontakttelefon *",
      contactPhonePlaceholder: "Ange kontakttelefon",
      contactPhoneRequired: "Kontakttelefon krävs",
      emailInvalid: "Ogiltigt e-postformat",
      country: "Land *",
      currency: "Valuta *",
      language: "Språk *",
      creating: "Skapar...",
      createStore: "Skapa butik",
      storeActive: "Aktiv butik",
      storeActiveHint:
        "När den är av är butiken inaktiv och visas inte i vanliga listor och flöden.",
    },
    bookkeeping: {
      unknownTitle: "Okänd integrationstyp",
      unknownMessage: "Integrationstypen stöds inte",
      connectionFailed: "Anslutning misslyckades",
      connecting: "Ansluter integration",
      pleaseWait: "Vänta medan vi slutför anslutningen...",
      completedTitle: "Integration slutförd",
      connectedSuccess: "Integrationen anslöts!",
      unknownError: "Ett okänt fel inträffade",
      invalidScope: "Ett internt fel har inträffat. Vänligen kontakta supporten.",
    },
    shopify: {
      connectionFailed: "Anslutning misslyckades",
      connecting: "Ansluter integration",
      pleaseWait: "Vänta medan vi slutför anslutningen...",
      completedTitle: "Integration slutförd",
      connectedSuccess: "Integrationen anslöts!",
      unknownError: "Ett okänt fel inträffade",
    },
    shopifyProvision: {
      shopDomain: "Butiksdomän",
      shopDomainPlaceholder: "din-butik.myshopify.com",
      shopDomainRequired: "Butiksdomän är obligatorisk",
      clientId: "Client ID",
      clientIdRequired: "Client ID är obligatoriskt",
      clientSecret: "Client secret",
      clientSecretRequired: "Client secret är obligatoriskt",
      guide: {
        title: "Konfiguration i Shopify Partner Dashboard",
        intro:
          "Skapa en anpassad app per handlare i Shopify Partner Dashboard innan du sparar uppgifterna i detta formulär. OAuth omdirigeras till app.kassaro.se.",
        redirectUrl: "https://app.kassaro.se/shopify/integration",
        scopes:
          "read_products, write_products, read_inventory, write_inventory, read_locations, read_publications, write_publications, read_orders",
        step1:
          "Logga in i Shopify Partner Dashboard på partners.shopify.com.",
        step2:
          "Skapa en ny app för handlaren och välj Custom distribution för deras butik. Skicka inte in appen till Shopify App Store.",
        step3:
          "Lägg till denna omdirigerings-URL under Allowed redirection URL(s): {{redirectUrl}}",
        step4: "Aktivera dessa Admin API-behörigheter: {{scopes}}.",
        step5:
          "Konfigurera obligatoriska compliance-webhooks (customers/data_request, customers/redact, shop/redact) till Kassaro Pub/Sub-ämnet och distribuera appversionen till handlarens butik.",
        step6:
          "Kopiera Client ID och Client secret från appens API-uppgifter.",
        step7:
          "Ange handlarens butiksdomän, Client ID och Client secret i integrationsformuläret och spara.",
        step8:
          "Klicka på Anslut Shopify i detta formulär för att slutföra OAuth, eller be handlaren ansluta från kassaappen under Integrationer → Shopify.",
      },
    },
    receiptsView: {
      title: "Kvitton",
      loading: "Laddar kvitton...",
      loadingDetail: "Laddar kvitto...",
      errorLoad: "Kunde inte ladda kvitton. Försök igen.",
      errorDetail: "Kunde inte ladda kvitto.",
      empty: "Inga kvitton hittades.",
      tableNumber: "Nummer",
      tableType: "Typ",
      tableDate: "Datum",
      tableStaff: "Personal",
      tableTotal: "Totalt",
      searchByNumber: "Sök på kvittonummer",
      searchPlaceholder: "Kvittonummer",
      searchInvalid: "Ange ett giltigt kvittonummer.",
      searchNotFound: "Kvitto hittades inte.",
      search: {
        show: "Sök",
        hide: "Dölj sökning",
      },
      backToList: "Tillbaka till listan",
      detailTitle: "Kvittodetaljer",
      filter: {
        type: "Typ",
        staff: "Personal",
        all: "Alla",
        dateRange: "Datum",
        date: "Datum",
        startTime: "Starttid",
        endTime: "Sluttid",
        clear: "Rensa filter",
        show: "Filter",
        hide: "Dölj filter",
        active: "Aktiva",
        presetToday: "Idag",
        presetYesterday: "Igår",
      },
      detail: {
        typeReceipt: "Kvitto",
        typeRefund: "Returkvitto",
        typePayout: "Utbetalning",
        companyOrgNumber: "Org.nr.",
        companyAddress: "Adress",
        createdAt: "Datum",
        items: "Rader",
        summary: "Sammanfattning",
        payments: "Betalningar",
        purchaseNote: "Köpanmärkning",
        customer: "Kund",
        fiscalization: "Fiskalisering",
        total: "Totalt",
        vatIncluded: "Varav moms",
        vatPercentage: "Moms {{percentage}}%",
        net: "Netto",
        rounding: "Öresavrundning",
        subtotal: "Delsumma",
        discount: "Rabatt",
        tip: "Dricks",
        staff: "Personal",
        prepTicketReference: "Referens",
        originalReceipt: "Originalkvitto",
        original: "Original",
        refund: "Retur",
        refundReceiptsCount: "Returer ({{count}})",
        paidVia: "Betald via {{brand}}",
        fiscalizationCashRegister: "Kassaregister",
        fiscalizationControlUnit: "Kontrollenhet",
        customerName: "Kund",
        customerEmail: "E-post",
        customerPhone: "Telefon",
        customerNote: "Anteckning",
        paymentDetails: {
          receivedAmount: "Mottaget",
          changeAmount: "Växel",
          invoiceNumber: "Fakturanr.",
          orderNumber: "Ordernr.",
          reference: "Referens",
          dueDate: "Förfallodatum",
          customer: "Kund",
          ocr: "OCR",
          orgNumber: "Org.nr.",
        },
        purchaseNoteName: "Namn",
        purchaseNotePhone: "Telefon",
        purchaseNoteSsn: "Personnummer",
        purchaseNoteProductInfo: "Produktinfo",
        purchaseNoteAddress: "Adress",
        purchaseNoteIdType: "ID-typ",
      },
    },
    publicReceipt: {
      loading: "Laddar kvitto...",
      notFoundTitle: "Kvitto hittades inte",
      notFound: "Kvittolänken är ogiltig.",
      errorGeneric: "Något gick fel. Försök igen.",
      saveTitle: "Spara ditt kvitto",
      saveDescription: "Ladda ner en PDF eller skicka kvittot till din e-post.",
      downloadPdf: "Ladda ner PDF",
      downloading: "Laddar ner...",
      emailPlaceholder: "E-postadress",
      emailInvalid: "Ogiltig e-postadress",
      emailSend: "Skicka via e-post",
      sending: "Skickar...",
      emailSuccess: "Kvittot har skickats till din e-post.",
    },
    sidebar: {
      store: "Butik",
      overview: "Översikt",
      statistics: "Statistik",
      receipts: "Kvitton",
      devices: "Enheter",
      users: "Användare",
      products: "Produkter",
      productImport: "Produktimport",
      giftcards: "Presentkort",
      creditNotes: "Tillgodokvitton",
      admin: "Admin",
      invoicing: "Fakturering",
      integrations: "Integrationer",
      paymentMethods: "Betalmetoder",
      aiAssistant: "AI-assistent",
      chatSessions: "Chatt-sessioner",
      catalog: "Katalog",
      stock: "Lager",
      settings: "Inställningar",
    },
    storeChatSessions: {
      title: "Chatt-sessioner",
      subtitle: "Bläddra bland konversationer och starta en ny session med ett första meddelande.",
      newSessionPlaceholder: "Skriv det första meddelandet för att starta en ny session…",
      newChat: "Ny chatt",
      starters: {
        setupTitle: "Sätt upp butiken",
        setupHint:
          "Välj ett koncept så ställer assistenten några frågor och tar fram ett förslag som du granskar innan något sparas.",
        tasksTitle: "Eller börja med något av detta",
        setup: {
          basic_retail: {
            label: "Butik",
            message: "Jag vill sätta upp butiken som en vanlig butik.",
          },
          cafe: {
            label: "Café",
            message: "Jag vill sätta upp butiken som ett café.",
          },
          restaurant: {
            label: "Restaurang",
            message: "Jag vill sätta upp butiken som en restaurang.",
          },
          bar: {
            label: "Bar",
            message: "Jag vill sätta upp butiken som en bar.",
          },
          takeaway: {
            label: "Gatukök / avhämtning",
            message: "Jag vill sätta upp butiken som ett gatukök med avhämtning.",
          },
          service: {
            label: "Salong / tjänster",
            message: "Jag vill sätta upp butiken som en salong som säljer tjänster.",
          },
        },
        tasks: {
          addProducts: {
            label: "Lägg till produkter",
            message: "Jag vill lägga till nya produkter.",
          },
          menuPhoto: {
            label: "Lägg in min meny från en bild",
            message: "Jag vill lägga in min meny. Jag bifogar en bild på den.",
          },
          layout: {
            label: "Ändra kassans layout",
            message: "Jag vill ändra vilka knappar och produkter som syns i kassan.",
          },
          receipt: {
            label: "Ändra kvittot",
            message: "Jag vill ändra vad som står på kvittot.",
          },
        },
      },
      startSession: "Starta session",
      creating: "Startar…",
      emptyList: "Inga sessioner ännu.",
      selectSession: "Välj en session till vänster för att visa konversationen.",
      noMessages: "Inga meddelanden i denna session ännu.",
      sessionIdPrefix: "Session",
      loadFailed: "Kunde inte ladda chatt-sessioner.",
      messagesLoadFailed: "Kunde inte ladda meddelanden för denna session.",
      createFailed: "Kunde inte starta session.",
      thinking: "Assistenten tänker…",
      replyPlaceholder: "Skriv ett meddelande…",
      dropFilesHint: "Släpp filer här",
      send: "Skicka",
      sending: "Skickar…",
      sendFailed: "Kunde inte skicka meddelandet.",
      agentProgress: {
        thinking: "Assistenten tänker…",
        get_store: "Hämtar butiksinställningar…",
        get_store_settings: "Hämtar butiksinställningar…",
        get_products: "Hämtar produkter…",
        get_product_groups: "Hämtar varugrupper…",
        get_modifiers: "Hämtar tillval…",
        get_modifier_groups: "Hämtar tillvalsgrupper…",
        get_layouts: "Hämtar layouter…",
        get_product_pages: "Hämtar produktsidor…",
        get_device_configs: "Hämtar enhetskonfigurationer…",
        get_devices: "Hämtar enheter…",
        get_prep_stations: "Hämtar bongplatser…",
        get_bookkeeping_accounts: "Hämtar bokföringskonton…",
        get_payment_methods: "Hämtar betalningsmetoder…",
        get_units: "Hämtar enheter…",
        get_courses: "Hämtar serveringar…",
        get_printers: "Hämtar skrivare…",
        get_floor_plans: "Hämtar bordsplaner…",
        get_floor_plan_schema: "Läser schema för bordsplaner…",
        get_lookup_schema: "Läser uppslagsdokumentation…",
        get_change_request_schema: "Läser schema för ändringsförslag…",
        get_change_request: "Kontrollerar ändringsförslag…",
        upsert_change_request: "Uppdaterar ändringsförslag…",
        kassaro_docs: "Söker i dokumentationen…",
        get_store_config: "Hämtar butikens konfiguration…",
        catalog_specialist: "Förbereder ändringar i katalogen…",
        settings_specialist: "Förbereder ändringar i inställningarna…",
        layout_specialist: "Förbereder ändringar i kassans layout…",
        get_layout_schema: "Läser schema för layouter…",
        get_offers: "Hämtar erbjudanden…",
        get_suppliers: "Hämtar leverantörer…",
        get_online_order_settings: "Hämtar inställningar för onlinebeställning…",
        list_store_templates: "Hämtar butikskoncept…",
        get_store_template: "Läser frågor för konceptet…",
        build_store_setup: "Bygger upp butiken…",
        transfer_to_StoreSetup: "Startar butiksuppsättningen…",
        transfer_to_KassaroAssistant: "Återgår till assistenten…",
        fallback: "Bearbetar din förfrågan…",
      },
      changeRequest: {
        title: "Ändringsförslag",
        before: "Före",
        after: "Efter",
        empty: "Inget ändringsförslag ännu. Assistenten kan lägga till ett när den föreslår ändringar.",
        approve: "Godkänn och verkställ",
        approving: "Verkställer…",
        approveFailed: "Kunde inte godkänna ändringsförslaget.",
        retry: "Försök igen",
        applied: "Verkställd",
        partiallyAppliedHint: "Verkställandet avbröts. Redan verkställda ändringar är sparade; be assistenten rätta resten och försök igen.",
        missingPermissions: "Du saknar behörighet att godkänna ändringar i: {{permissions}}",
        permissions: {
          PRODUCT_MANAGEMENT: "Produkthantering",
          STORE_SETTINGS: "Butiksinställningar",
          RESTAURANT_SETUP: "Restauranginställningar",
          MANAGE_FLOOR_PLANS: "Bordskartor",
          MANAGE_LAYOUTS: "Layouter",
          MANAGE_PRODUCT_PAGES: "Produktsidor",
          MANAGE_ONLINE_ORDERS: "Onlinebeställning",
          DEVICE_CONFIGURATION: "Enhetskonfiguration",
          PAYMENT_METHOD_MANAGEMENT: "Betalningsmetoder",
          PRINTERS_MANAGEMENT: "Skrivare",
          MANAGE_OFFERS: "Erbjudanden",
        },
        more: "och {{count}} till",
        layoutItemTypes: {
          PRODUCT: "Produkt",
          PRODUCT_PAGE: "Produktsida",
          MENU_LINK: "Menylänk",
          WEBSITE: "Webbsida",
          DISCOUNT: "Rabatt",
          GIFT_CARD: "Presentkort",
          PRODUCT_SEARCH: "Sök produkt",
          BARCODE_MODAL: "Streckkod",
          SCALE_VALUE: "Våg",
          SHOW_CLOCK: "Klocka",
          SHOW_DATE: "Datum",
          OPEN_CASHBOX: "Öppna kassalåda",
          ACTIVE_TAB: "Notor",
          SPLIT_TAB: "Dela nota",
          PRINT_PROFORMA: "Skriv ut proforma",
          FORWARD_PREP_STATION: "Skicka till kök",
          WAIT_PREP_STATION: "Vänta med köket",
          COMBINED_PREP_TICKET: "Samlad bong",
          TOGGLE_TAKEAWAY: "Avhämtning",
          TEXT_ITEM: "Text",
          SELECT_STORE: "Välj butik",
          SET_REFERENCE: "Referens",
          ORDER_PAGE: "Beställningar",
          STAFF_SELECT: "Välj personal",
          SHOW_ALL: "Visa alla",
          PAYMENT_METHOD: "Betalsätt",
          SELECT_CUSTOMER: "Välj kund",
          SERVICE_ORDER: "Serviceorder",
          SERVICE_ORDER_DEPOSIT: "Handpenning",
        },
        statuses: {
          DRAFT: "Utkast",
          PARTIALLY_APPLIED: "Delvis verkställd",
          APPROVED: "Godkänd",
          DISCARDED: "Kasserad",
        },
        showDetails: "Visa detaljer",
        hideDetails: "Dölj detaljer",
        variantCount: "{{count}} varianter",
        values: {
          ALWAYS: "Alltid",
          OFF: "Av",
          ON_LONG_PRESS: "Vid långt tryck",
          PRODUCT: "Vara",
          SERVICE: "Tjänst",
          CASH: "Kontant",
          SWISH_COMPANY: "Swish",
          OTHER: "Övrigt",
          GIFT_CARD: "Presentkort",
          CREDIT_NOTE: "Tillgodokvitto",
          IP_PRINTER: "Nätverksskrivare",
          BUILT_IN_SUNMI: "Inbyggd skrivare",
          NAME: "Namn",
          PIN: "PIN-kod",
          BUY_X_PAY_Y: "Köp X betala för Y",
          QUANTITY_PRICE: "Mängdpris",
          FIXED_PRICE: "Fast pris",
          PERCENTAGE: "Procentrabatt",
          COMBO: "Kombo",
          RECT: "Rektangulärt",
          ROUND: "Runt",
        },
        operations: {
          product_create: "Ny produkt",
          product_update: "Uppdatera produkt",
          product_delete: "Ta bort produkt",
          group_create: "Ny varugrupp",
          group_update: "Uppdatera varugrupp",
          group_delete: "Ta bort varugrupp",
          modifier_create: "Nytt tillval",
          modifier_update: "Uppdatera tillval",
          modifier_delete: "Ta bort tillval",
          modifier_group_create: "Ny tillvalsgrupp",
          modifier_group_update: "Uppdatera tillvalsgrupp",
          modifier_group_delete: "Ta bort tillvalsgrupp",
          unit_create: "Ny enhet",
          unit_update: "Uppdatera enhet",
          unit_delete: "Ta bort enhet",
          prep_station_create: "Ny bongplats",
          prep_station_update: "Uppdatera bongplats",
          prep_station_delete: "Ta bort bongplats",
          bookkeeping_account_create: "Nytt bokföringskonto",
          bookkeeping_account_update: "Uppdatera bokföringskonto",
          bookkeeping_account_delete: "Ta bort bokföringskonto",
          floor_plan_create: "Ny bordskarta",
          floor_plan_update: "Uppdatera bordskarta",
          floor_plan_delete: "Ta bort bordskarta",
          layout_create: "Ny layout",
          layout_update: "Uppdatera layout",
          layout_delete: "Ta bort layout",
          product_page_create: "Ny produktsida",
          product_page_update: "Uppdatera produktsida",
          product_page_add_items: "Lägg till på produktsida",
          product_page_delete: "Ta bort produktsida",
          store_settings_update: "Uppdatera butiksinställningar",
          online_order_settings_update: "Uppdatera onlinebeställning",
          device_config_create: "Ny enhetskonfiguration",
          device_config_update: "Uppdatera enhetskonfiguration",
          device_config_delete: "Ta bort enhetskonfiguration",
          payment_method_create: "Ny betalningsmetod",
          payment_method_update: "Uppdatera betalningsmetod",
          payment_method_delete: "Ta bort betalningsmetod",
          printer_create: "Ny skrivare",
          printer_update: "Uppdatera skrivare",
          printer_delete: "Ta bort skrivare",
          course_create: "Ny servering",
          course_update: "Uppdatera servering",
          course_delete: "Ta bort servering",
          offer_create: "Nytt erbjudande",
          offer_update: "Uppdatera erbjudande",
          offer_delete: "Ta bort erbjudande",
          supplier_create: "Ny leverantör",
          supplier_update: "Uppdatera leverantör",
          supplier_delete: "Ta bort leverantör",
        },
        domains: {
          product: "Produkter",
          group: "Varugrupper",
          modifier: "Tillval",
          modifier_group: "Tillvalsgrupper",
          unit: "Enheter",
          prep_station: "Bongplatser",
          bookkeeping_account: "Bokföringskonton",
          floor_plan: "Bordskartor",
          layout: "Layouter",
          product_page: "Produktsidor",
          store_settings: "Butiksinställningar",
          online_order_settings: "Onlinebeställning",
          device_config: "Enhetskonfigurationer",
          payment_method: "Betalningsmetoder",
          printer: "Skrivare",
          course: "Serveringar",
          offer: "Erbjudanden",
          supplier: "Leverantörer",
        },
        errors: {
          change_request_apply_unresolved_operation_ref:
            "Ändringsförslaget refererar till en åtgärd som saknas eller inte har körts ännu. Be assistenten uppdatera utkastet.",
          change_request_apply_cyclic_operation_refs:
            "Ändringsförslaget innehåller cirkulära referenser mellan åtgärder och kan inte verkställas.",
          change_request_apply_invalid_operations:
            "Ändringsförslaget innehåller ogiltiga åtgärder och kan inte verkställas.",
          change_request_apply_create_payload_invalid:
            "En åtgärd i ändringsförslaget har ogiltiga värden och kan inte verkställas.",
          change_request_apply_update_patch_invalid:
            "En uppdateringsåtgärd i ändringsförslaget har ogiltiga värden.",
          change_request_apply_product_not_found:
            "Produkten som ändringsförslaget refererar till hittades inte.",
          change_request_apply_group_not_found:
            "Produktgruppen som ändringsförslaget refererar till hittades inte.",
          change_request_apply_modifier_not_found:
            "Tillvalet som ändringsförslaget refererar till hittades inte.",
          change_request_apply_modifier_group_not_found:
            "Tillvalsgruppen som ändringsförslaget refererar till hittades inte.",
          change_request_apply_unit_not_found:
            "Enheten som ändringsförslaget refererar till hittades inte.",
          change_request_apply_prep_station_not_found:
            "Bongplatsen som ändringsförslaget refererar till hittades inte.",
          change_request_apply_bookkeeping_account_not_found:
            "Bokföringskontot som ändringsförslaget refererar till hittades inte.",
          change_request_apply_floor_plan_not_found:
            "Bordsplanen som ändringsförslaget refererar till hittades inte.",
          change_request_apply_layout_not_found:
            "Layouten som ändringsförslaget refererar till hittades inte.",
          change_request_apply_product_page_not_found:
            "Produktsidan som ändringsförslaget refererar till hittades inte.",
          change_request_apply_device_config_not_found:
            "Enhetskonfigurationen som ändringsförslaget refererar till hittades inte.",
          change_request_apply_payment_method_not_found:
            "Betalningsmetoden som ändringsförslaget refererar till hittades inte.",
          change_request_apply_printer_not_found:
            "Skrivaren som ändringsförslaget refererar till hittades inte.",
          change_request_apply_course_not_found:
            "Serveringen som ändringsförslaget refererar till hittades inte.",
          change_request_apply_offer_not_found:
            "Erbjudandet som ändringsförslaget refererar till hittades inte.",
          change_request_apply_supplier_not_found:
            "Leverantören som ändringsförslaget refererar till hittades inte.",
        },
        yes: "Ja",
        no: "Nej",
        fields: {
          id: "ID",
          name: "Namn",
          type: "Typ",
          unitPrice: "Pris",
          VAT: "Moms",
          openPrice: "Öppet pris",
          groupId: "Grupp",
          unitId: "Enhet",
          bookkeepingAccountId: "Bokföringskonto",
          bookkeepingCostcenter: "Kostnadsställe",
          information: "Information",
          image: "Bild",
          purchasePrice: "Inköpspris",
          barcode: "Streckkod",
          stockCount: "Lager",
          articleNumber: "Artikelnummer",
          manufacturerArticleNumber: "Tillv. art.nr",
          manufacturerBarcode: "Tillv. streckkod",
          extraFields: "Extrafält",
          variants: "Varianter",
          prepStationId: "Bongplats",
          courseId: "Servering",
          requireReference: "Kräv referens",
          modifiers: "Tillval",
          modifierGroups: "Tillvalsgrupper",
          alwaysAppliedModifiers: "Alltid tillämpade tillval",
          takeawayVAT: "Avhämtning moms",
          takeawayBookkeepingAccountId: "Avhämtning bokföringskonto",
          takeawayPrice: "Avhämtningspris",
          description: "Beskrivning",
          tags: "Taggar",
          price: "Pris",
          productGroupId: "Varugrupp",
          internal: "Endast internt",
          minAmount: "Minsta antal",
          maxAmount: "Största antal",
          alwaysPrompt: "Fråga alltid vid tillägg",
          suffix: "Suffix",
          decimals: "Decimaler",
          enableSerialScale: "Serievåg",
          serialScaleUnit: "Vågenhet",
          printerIds: "Skrivare",
          servingScope: "Serveringar på notan",
          prepStationScope: "Ta med andra bongplatser på notan",
          simplifyItemsFromOtherPrepStations: "Dölj tillval från andra bongplatser",
          accountNumber: "Kontonummer",
          mapWidth: "Kartbredd",
          mapHeight: "Karthöjd",
          mapEnabled: "Karta aktiverad",
          tables: "Bord",
          decorations: "Dekorationer",
          topButtons: "Knappar överst",
          bottomButtons: "Knappar nederst",
          leftButtons: "Knappar vänster",
          rightButtons: "Knappar höger",
          checkoutButtons: "Kassaknappar",
          defaultProductPageId: "Startsida",
          items: "Knappar",
          layoutId: "Layout",
          receiptText: "Kvittotext",
          tipPromptBehavior: "Dricks",
          paymentMethodsOrder: "Betalsättens ordning",
          swishNumber: "Swish-nummer",
          sortOrder: "Ordning",
        },
      },
    },
    storeAi: {
      badge: "AI-assistent",
      subtitle:
        "Ställ frågor om butikens produkter. Nya produkter eller ändringar kräver ditt godkännande innan de sparas.",
      approvalHint:
        "När assistenten föreslår en ändring, granska kortet nedan innan det sparas.",
      pendingBanner: "Du har en väntande ändring att granska.",
      scrollToProposal: "Gå till förslag",
      thinking: "Assistenten tänker…",
      proposedNewProduct: "Föreslagen ny produkt",
      proposedProductChange: "Föreslagen produktändring",
      kindCreate: "Skapa",
      kindUpdate: "Uppdatera",
      before: "Före",
      after: "Efter",
      approve: "Godkänn",
      rejecting: "Avvisar…",
      approving: "Godkänner…",
      reject: "Avvisa",
      placeholder: "Skriv till assistenten…",
      send: "Skicka",
      sending: "Skickar…",
      unavailable: "Assistenten är inte tillgänglig.",
      sendFailed: "Kunde inte skicka meddelandet.",
      changeApplied: "Ändringen tillämpades: {{name}}.",
      productLinkIntro: "Du kan öppna produkter här:",
      openProducts: "Produkter",
      approveFailed: "Kunde inte godkänna ändringen.",
      rejectFailed: "Kunde inte avvisa ändringen.",
      vat: "Moms",
      batchCreateSummary: "{{count}} nya produkter i detta förslag.",
      batchUpdateSummary: "{{count}} produkter i detta förslag.",
      changesAppliedBatch: "Ändringar tillämpades: {{names}}.",
      productsLinkIntro: "Uppdateringar tillämpades på {{count}} produkter.",
      addImages: "Lägg till bilder",
      imageAlt: "Bifogad bild",
      removeImage: "Ta bort",
      imageTooMany: "Högst 8 bilder per meddelande.",
      imageTooLarge: "Varje bild får vara högst 8 MB.",
      imagesTotalTooLarge: "Bilderna tillsammans får vara högst 25 MB.",
      imageTypeInvalid: "Endast JPEG, PNG, WebP och GIF tillåts.",
    },
  },
};
